import '../../assets/index59.css';var ri = Object.defineProperty, oi = Object.defineProperties;
var ii = Object.getOwnPropertyDescriptors;
var Pn = Object.getOwnPropertySymbols;
var si = Object.prototype.hasOwnProperty, ci = Object.prototype.propertyIsEnumerable;
var rt = Math.pow, Rn = (e, t, n) => t in e ? ri(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, N = (e, t) => {
  for (var n in t || (t = {}))
    si.call(t, n) && Rn(e, n, t[n]);
  if (Pn)
    for (var n of Pn(t))
      ci.call(t, n) && Rn(e, n, t[n]);
  return e;
}, C = (e, t) => oi(e, ii(t));
import { jsx as U, jsxs as Pe } from "react/jsx-runtime";
import * as R from "react";
import P, { useState as en, useRef as M, useEffect as re, useContext as Wr, useLayoutEffect as ai, forwardRef as li } from "react";
import ui, { unstable_batchedUpdates as di, flushSync as Ur } from "react-dom";
import { g as pi } from "../../_commonjsHelpers-lRDecupM.js";
import { r as fi } from "../../index-CcXU3z6b.js";
import { GripVerticalFarFAIcon as Tn, ArrowUpFarFAIcon as gi, ArrowDownFarFAIcon as mi } from "../Icons/index.js";
import { Button as Ln } from "../Button/index.js";
import { F as Bn } from "../../Flex-BcSdq2bJ.js";
import { G as bi } from "../../Group-CbE78j-X.js";
function Me(e) {
  "@babel/helpers - typeof";
  return Me = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Me(e);
}
function hi(e, t) {
  if (Me(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Me(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vi(e) {
  var t = hi(e, "string");
  return Me(t) == "symbol" ? t : t + "";
}
function yi(e, t, n) {
  return (t = vi(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Vn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vn(Object(n), !0).forEach(function(r) {
      yi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function q(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var $n = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Gn = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Fn = {
  INIT: "@@redux/INIT" + Gn(),
  REPLACE: "@@redux/REPLACE" + Gn()
};
function Ei(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Di(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (Oi(e)) return "date";
  if (Si(e)) return "error";
  var n = Ni(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function Ni(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Si(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function Oi(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function fe(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Di(e)), t;
}
function Hr(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? q(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n == "undefined" && (n = t, t = void 0), typeof n != "undefined") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? q(1) : "Expected the enhancer to be a function. Instead, received: '" + fe(n) + "'");
    return n(Hr)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? q(2) : "Expected the root reducer to be a function. Instead, received: '" + fe(e) + "'");
  var o = e, i = t, s = [], c = s, l = !1;
  function u() {
    c === s && (c = s.slice());
  }
  function p() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? q(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function a(b) {
    if (typeof b != "function")
      throw new Error(process.env.NODE_ENV === "production" ? q(4) : "Expected the listener to be a function. Instead, received: '" + fe(b) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? q(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return u(), c.push(b), function() {
      if (m) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? q(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, u();
        var y = c.indexOf(b);
        c.splice(y, 1), s = null;
      }
    };
  }
  function d(b) {
    if (!Ei(b))
      throw new Error(process.env.NODE_ENV === "production" ? q(7) : "Actions must be plain objects. Instead, the actual type was: '" + fe(b) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof b.type == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? q(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? q(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, i = o(i, b);
    } finally {
      l = !1;
    }
    for (var m = s = c, v = 0; v < m.length; v++) {
      var y = m[v];
      y();
    }
    return b;
  }
  function f(b) {
    if (typeof b != "function")
      throw new Error(process.env.NODE_ENV === "production" ? q(10) : "Expected the nextReducer to be a function. Instead, received: '" + fe(b));
    o = b, d({
      type: Fn.REPLACE
    });
  }
  function h() {
    var b, m = a;
    return b = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? q(11) : "Expected the observer to be an object. Instead, received: '" + fe(y) + "'");
        function O() {
          y.next && y.next(p());
        }
        O();
        var D = m(O);
        return {
          unsubscribe: D
        };
      }
    }, b[$n] = function() {
      return this;
    }, b;
  }
  return d({
    type: Fn.INIT
  }), r = {
    dispatch: d,
    subscribe: a,
    getState: p,
    replaceReducer: f
  }, r[$n] = h, r;
}
function Wn(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function Un(e, t) {
  if (typeof e == "function")
    return Wn(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? q(16) : "bindActionCreators expected an object or a function, but instead received: '" + fe(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var n = {};
  for (var r in e) {
    var o = e[r];
    typeof o == "function" && (n[r] = Wn(o, t));
  }
  return n;
}
function kr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, o) {
    return function() {
      return r(o.apply(void 0, arguments));
    };
  });
}
function xi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var o = r.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? q(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, s = {
        getState: o.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, c = t.map(function(l) {
        return l(s);
      });
      return i = kr.apply(void 0, c)(o.dispatch), Mn(Mn({}, o), {}, {
        dispatch: i
      });
    };
  };
}
var ot = { exports: {} }, It = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hn;
function Ii() {
  if (Hn) return It;
  Hn = 1;
  var e = P;
  function t(a, d) {
    return a === d && (a !== 0 || 1 / a === 1 / d) || a !== a && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, s = e.useDebugValue;
  function c(a, d) {
    var f = d(), h = r({ inst: { value: f, getSnapshot: d } }), b = h[0].inst, m = h[1];
    return i(
      function() {
        b.value = f, b.getSnapshot = d, l(b) && m({ inst: b });
      },
      [a, f, d]
    ), o(
      function() {
        return l(b) && m({ inst: b }), a(function() {
          l(b) && m({ inst: b });
        });
      },
      [a]
    ), s(f), f;
  }
  function l(a) {
    var d = a.getSnapshot;
    a = a.value;
    try {
      var f = d();
      return !n(a, f);
    } catch (h) {
      return !0;
    }
  }
  function u(a, d) {
    return d();
  }
  var p = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? u : c;
  return It.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, It;
}
var wt = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kn;
function wi() {
  return kn || (kn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(f, h) {
      return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
    }
    function t(f, h) {
      p || o.startTransition === void 0 || (p = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = h();
      if (!a) {
        var m = h();
        i(b, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), a = !0);
      }
      m = s({
        inst: { value: b, getSnapshot: h }
      });
      var v = m[0].inst, y = m[1];
      return l(
        function() {
          v.value = b, v.getSnapshot = h, n(v) && y({ inst: v });
        },
        [f, b, h]
      ), c(
        function() {
          return n(v) && y({ inst: v }), f(function() {
            n(v) && y({ inst: v });
          });
        },
        [f]
      ), u(b), b;
    }
    function n(f) {
      var h = f.getSnapshot;
      f = f.value;
      try {
        var b = h();
        return !i(f, b);
      } catch (m) {
        return !0;
      }
    }
    function r(f, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = P, i = typeof Object.is == "function" ? Object.is : e, s = o.useState, c = o.useEffect, l = o.useLayoutEffect, u = o.useDebugValue, p = !1, a = !1, d = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? r : t;
    wt.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), wt;
}
var jn;
function tn() {
  return jn || (jn = 1, process.env.NODE_ENV === "production" ? ot.exports = Ii() : ot.exports = wi()), ot.exports;
}
var Ci = tn(), it = { exports: {} }, Ct = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qn;
function _i() {
  if (qn) return Ct;
  qn = 1;
  var e = P, t = tn();
  function n(u, p) {
    return u === p && (u !== 0 || 1 / u === 1 / p) || u !== u && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, s = e.useEffect, c = e.useMemo, l = e.useDebugValue;
  return Ct.useSyncExternalStoreWithSelector = function(u, p, a, d, f) {
    var h = i(null);
    if (h.current === null) {
      var b = { hasValue: !1, value: null };
      h.current = b;
    } else b = h.current;
    h = c(
      function() {
        function v(E) {
          if (!y) {
            if (y = !0, O = E, E = d(E), f !== void 0 && b.hasValue) {
              var w = b.value;
              if (f(w, E))
                return D = w;
            }
            return D = E;
          }
          if (w = D, r(O, E)) return w;
          var _ = d(E);
          return f !== void 0 && f(w, _) ? (O = E, w) : (O = E, D = _);
        }
        var y = !1, O, D, S = a === void 0 ? null : a;
        return [
          function() {
            return v(p());
          },
          S === null ? void 0 : function() {
            return v(S());
          }
        ];
      },
      [p, a, d, f]
    );
    var m = o(u, h[0], h[1]);
    return s(
      function() {
        b.hasValue = !0, b.value = m;
      },
      [m]
    ), l(m), m;
  }, Ct;
}
var _t = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zn;
function Ai() {
  return zn || (zn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u, p) {
      return u === p && (u !== 0 || 1 / u === 1 / p) || u !== u && p !== p;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = P, n = tn(), r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, i = t.useRef, s = t.useEffect, c = t.useMemo, l = t.useDebugValue;
    _t.useSyncExternalStoreWithSelector = function(u, p, a, d, f) {
      var h = i(null);
      if (h.current === null) {
        var b = { hasValue: !1, value: null };
        h.current = b;
      } else b = h.current;
      h = c(
        function() {
          function v(E) {
            if (!y) {
              if (y = !0, O = E, E = d(E), f !== void 0 && b.hasValue) {
                var w = b.value;
                if (f(w, E))
                  return D = w;
              }
              return D = E;
            }
            if (w = D, r(O, E))
              return w;
            var _ = d(E);
            return f !== void 0 && f(w, _) ? (O = E, w) : (O = E, D = _);
          }
          var y = !1, O, D, S = a === void 0 ? null : a;
          return [
            function() {
              return v(p());
            },
            S === null ? void 0 : function() {
              return v(S());
            }
          ];
        },
        [p, a, d, f]
      );
      var m = o(u, h[0], h[1]);
      return s(
        function() {
          b.hasValue = !0, b.value = m;
        },
        [m]
      ), l(m), m;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), _t;
}
var Yn;
function Pi() {
  return Yn || (Yn = 1, process.env.NODE_ENV === "production" ? it.exports = _i() : it.exports = Ai()), it.exports;
}
Pi();
function Ri(e) {
  e();
}
let jr = Ri;
const Ti = (e) => jr = e, Li = () => jr, Kn = Symbol.for("react-redux-context"), Xn = typeof globalThis != "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Bi() {
  var e;
  if (!R.createContext) return {};
  const t = (e = Xn[Kn]) != null ? e : Xn[Kn] = /* @__PURE__ */ new Map();
  let n = t.get(R.createContext);
  return n || (n = R.createContext(null), process.env.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), t.set(R.createContext, n)), n;
}
const qr = /* @__PURE__ */ Bi(), Vi = () => {
  throw new Error("uSES not initialized!");
};
function se() {
  return se = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, se.apply(null, arguments);
}
function zr(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var At, Jn;
function Mi() {
  if (Jn) return At;
  Jn = 1;
  var e = fi(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = r, i[e.Memo] = o;
  function s(h) {
    return e.isMemo(h) ? o : i[h.$$typeof] || t;
  }
  var c = Object.defineProperty, l = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, a = Object.getPrototypeOf, d = Object.prototype;
  function f(h, b, m) {
    if (typeof b != "string") {
      if (d) {
        var v = a(b);
        v && v !== d && f(h, v, m);
      }
      var y = l(b);
      u && (y = y.concat(u(b)));
      for (var O = s(h), D = s(b), S = 0; S < y.length; ++S) {
        var E = y[S];
        if (!n[E] && !(m && m[E]) && !(D && D[E]) && !(O && O[E])) {
          var w = p(b, E);
          try {
            c(h, E, w);
          } catch (_) {
          }
        }
      }
    }
    return h;
  }
  return At = f, At;
}
var $i = Mi();
const Zn = /* @__PURE__ */ pi($i);
var st = { exports: {} }, T = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qn;
function Gi() {
  if (Qn) return T;
  Qn = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), a = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function b(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case o:
            case r:
            case u:
            case p:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case c:
                case s:
                case l:
                case d:
                case a:
                case i:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return T.ContextConsumer = s, T.ContextProvider = i, T.Element = e, T.ForwardRef = l, T.Fragment = n, T.Lazy = d, T.Memo = a, T.Portal = t, T.Profiler = o, T.StrictMode = r, T.Suspense = u, T.SuspenseList = p, T.isAsyncMode = function() {
    return !1;
  }, T.isConcurrentMode = function() {
    return !1;
  }, T.isContextConsumer = function(m) {
    return b(m) === s;
  }, T.isContextProvider = function(m) {
    return b(m) === i;
  }, T.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, T.isForwardRef = function(m) {
    return b(m) === l;
  }, T.isFragment = function(m) {
    return b(m) === n;
  }, T.isLazy = function(m) {
    return b(m) === d;
  }, T.isMemo = function(m) {
    return b(m) === a;
  }, T.isPortal = function(m) {
    return b(m) === t;
  }, T.isProfiler = function(m) {
    return b(m) === o;
  }, T.isStrictMode = function(m) {
    return b(m) === r;
  }, T.isSuspense = function(m) {
    return b(m) === u;
  }, T.isSuspenseList = function(m) {
    return b(m) === p;
  }, T.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === o || m === r || m === u || m === p || m === f || typeof m == "object" && m !== null && (m.$$typeof === d || m.$$typeof === a || m.$$typeof === i || m.$$typeof === s || m.$$typeof === l || m.$$typeof === h || m.getModuleId !== void 0);
  }, T.typeOf = b, T;
}
var L = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var er;
function Fi() {
  return er || (er = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), a = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), h = !1, b = !1, m = !1, v = !1, y = !1, O;
    O = Symbol.for("react.module.reference");
    function D(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === n || I === o || y || I === r || I === u || I === p || v || I === f || h || b || m || typeof I == "object" && I !== null && (I.$$typeof === d || I.$$typeof === a || I.$$typeof === i || I.$$typeof === s || I.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === O || I.getModuleId !== void 0));
    }
    function S(I) {
      if (typeof I == "object" && I !== null) {
        var xt = I.$$typeof;
        switch (xt) {
          case e:
            var nt = I.type;
            switch (nt) {
              case n:
              case o:
              case r:
              case u:
              case p:
                return nt;
              default:
                var An = nt && nt.$$typeof;
                switch (An) {
                  case c:
                  case s:
                  case l:
                  case d:
                  case a:
                  case i:
                    return An;
                  default:
                    return xt;
                }
            }
          case t:
            return xt;
        }
      }
    }
    var E = s, w = i, _ = e, H = l, B = n, k = d, $ = a, X = t, oe = o, J = r, he = u, Oe = p, ie = !1, xe = !1;
    function Qe(I) {
      return ie || (ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ie(I) {
      return xe || (xe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function we(I) {
      return S(I) === s;
    }
    function ue(I) {
      return S(I) === i;
    }
    function et(I) {
      return typeof I == "object" && I !== null && I.$$typeof === e;
    }
    function Ce(I) {
      return S(I) === l;
    }
    function _e(I) {
      return S(I) === n;
    }
    function tt(I) {
      return S(I) === d;
    }
    function Ot(I) {
      return S(I) === a;
    }
    function ve(I) {
      return S(I) === t;
    }
    function Ae(I) {
      return S(I) === o;
    }
    function _n(I) {
      return S(I) === r;
    }
    function Z(I) {
      return S(I) === u;
    }
    function de(I) {
      return S(I) === p;
    }
    L.ContextConsumer = E, L.ContextProvider = w, L.Element = _, L.ForwardRef = H, L.Fragment = B, L.Lazy = k, L.Memo = $, L.Portal = X, L.Profiler = oe, L.StrictMode = J, L.Suspense = he, L.SuspenseList = Oe, L.isAsyncMode = Qe, L.isConcurrentMode = Ie, L.isContextConsumer = we, L.isContextProvider = ue, L.isElement = et, L.isForwardRef = Ce, L.isFragment = _e, L.isLazy = tt, L.isMemo = Ot, L.isPortal = ve, L.isProfiler = Ae, L.isStrictMode = _n, L.isSuspense = Z, L.isSuspenseList = de, L.isValidElementType = D, L.typeOf = S;
  }()), L;
}
var tr;
function Wi() {
  return tr || (tr = 1, process.env.NODE_ENV === "production" ? st.exports = Gi() : st.exports = Fi()), st.exports;
}
var nr = Wi();
function nn(e) {
  typeof console != "undefined" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {
  }
}
function Pt(e, t) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || nn(`The selector for ${t} of connect did not specify a value for dependsOnOwnProps.`));
  else throw new Error(`Unexpected value for ${t} in connect.`);
}
function Ui(e, t, n) {
  Pt(e, "mapStateToProps"), Pt(t, "mapDispatchToProps"), Pt(n, "mergeProps");
}
const Hi = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function ki(e, t, n, r, {
  areStatesEqual: o,
  areOwnPropsEqual: i,
  areStatePropsEqual: s
}) {
  let c = !1, l, u, p, a, d;
  function f(y, O) {
    return l = y, u = O, p = e(l, u), a = t(r, u), d = n(p, a, u), c = !0, d;
  }
  function h() {
    return p = e(l, u), t.dependsOnOwnProps && (a = t(r, u)), d = n(p, a, u), d;
  }
  function b() {
    return e.dependsOnOwnProps && (p = e(l, u)), t.dependsOnOwnProps && (a = t(r, u)), d = n(p, a, u), d;
  }
  function m() {
    const y = e(l, u), O = !s(y, p);
    return p = y, O && (d = n(p, a, u)), d;
  }
  function v(y, O) {
    const D = !i(O, u), S = !o(y, l, O, u);
    return l = y, u = O, D && S ? h() : D ? b() : S ? m() : d;
  }
  return function(O, D) {
    return c ? v(O, D) : f(O, D);
  };
}
function ji(e, t) {
  let {
    initMapStateToProps: n,
    initMapDispatchToProps: r,
    initMergeProps: o
  } = t, i = zr(t, Hi);
  const s = n(e, i), c = r(e, i), l = o(e, i);
  return process.env.NODE_ENV !== "production" && Ui(s, c, l), ki(s, c, l, e, i);
}
function qi(e, t) {
  const n = {};
  for (const r in e) {
    const o = e[r];
    typeof o == "function" && (n[r] = (...i) => t(o(...i)));
  }
  return n;
}
function zi(e) {
  if (typeof e != "object" || e === null) return !1;
  let t = Object.getPrototypeOf(e);
  if (t === null) return !0;
  let n = t;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function Yr(e, t, n) {
  zi(e) || nn(`${n}() in ${t} must return a plain object. Instead received ${e}.`);
}
function qt(e) {
  return function(n) {
    const r = e(n);
    function o() {
      return r;
    }
    return o.dependsOnOwnProps = !1, o;
  };
}
function rr(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function Kr(e, t) {
  return function(r, {
    displayName: o
  }) {
    const i = function(c, l) {
      return i.dependsOnOwnProps ? i.mapToProps(c, l) : i.mapToProps(c, void 0);
    };
    return i.dependsOnOwnProps = !0, i.mapToProps = function(c, l) {
      i.mapToProps = e, i.dependsOnOwnProps = rr(e);
      let u = i(c, l);
      return typeof u == "function" && (i.mapToProps = u, i.dependsOnOwnProps = rr(u), u = i(c, l)), process.env.NODE_ENV !== "production" && Yr(u, o, t), u;
    }, i;
  };
}
function rn(e, t) {
  return (n, r) => {
    throw new Error(`Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`);
  };
}
function Yi(e) {
  return e && typeof e == "object" ? qt((t) => (
    // @ts-ignore
    qi(e, t)
  )) : e ? typeof e == "function" ? (
    // @ts-ignore
    Kr(e, "mapDispatchToProps")
  ) : rn(e, "mapDispatchToProps") : qt((t) => ({
    dispatch: t
  }));
}
function Ki(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    Kr(e, "mapStateToProps")
  ) : rn(e, "mapStateToProps") : qt(() => ({}));
}
function Xi(e, t, n) {
  return se({}, n, e, t);
}
function Ji(e) {
  return function(n, {
    displayName: r,
    areMergedPropsEqual: o
  }) {
    let i = !1, s;
    return function(l, u, p) {
      const a = e(l, u, p);
      return i ? o(a, s) || (s = a) : (i = !0, s = a, process.env.NODE_ENV !== "production" && Yr(s, r, "mergeProps")), s;
    };
  };
}
function Zi(e) {
  return e ? typeof e == "function" ? Ji(e) : rn(e, "mergeProps") : () => Xi;
}
function Qi() {
  const e = Li();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], o = t;
      for (; o; )
        r.push(o), o = o.next;
      return r;
    },
    subscribe(r) {
      let o = !0, i = n = {
        callback: r,
        next: null,
        prev: n
      };
      return i.prev ? i.prev.next = i : t = i, function() {
        !o || t === null || (o = !1, i.next ? i.next.prev = i.prev : n = i.prev, i.prev ? i.prev.next = i.next : t = i.next);
      };
    }
  };
}
const or = {
  notify() {
  },
  get: () => []
};
function Xr(e, t) {
  let n, r = or, o = 0, i = !1;
  function s(b) {
    p();
    const m = r.subscribe(b);
    let v = !1;
    return () => {
      v || (v = !0, m(), a());
    };
  }
  function c() {
    r.notify();
  }
  function l() {
    h.onStateChange && h.onStateChange();
  }
  function u() {
    return i;
  }
  function p() {
    o++, n || (n = t ? t.addNestedSub(l) : e.subscribe(l), r = Qi());
  }
  function a() {
    o--, n && o === 0 && (n(), n = void 0, r.clear(), r = or);
  }
  function d() {
    i || (i = !0, p());
  }
  function f() {
    i && (i = !1, a());
  }
  const h = {
    addNestedSub: s,
    notifyNestedSubs: c,
    handleChangeWrapper: l,
    isSubscribed: u,
    trySubscribe: d,
    tryUnsubscribe: f,
    getListeners: () => r
  };
  return h;
}
const es = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", pt = es ? R.useLayoutEffect : R.useEffect;
function ir(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Rt(e, t) {
  if (ir(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let o = 0; o < n.length; o++)
    if (!Object.prototype.hasOwnProperty.call(t, n[o]) || !ir(e[n[o]], t[n[o]]))
      return !1;
  return !0;
}
const ts = ["reactReduxForwardedRef"];
let Jr = Vi;
const ns = (e) => {
  Jr = e;
}, rs = [null, null], os = (e) => {
  try {
    return JSON.stringify(e);
  } catch (t) {
    return String(e);
  }
};
function is(e, t, n) {
  pt(() => e(...t), n);
}
function ss(e, t, n, r, o, i) {
  e.current = r, n.current = !1, o.current && (o.current = null, i());
}
function cs(e, t, n, r, o, i, s, c, l, u, p) {
  if (!e) return () => {
  };
  let a = !1, d = null;
  const f = () => {
    if (a || !c.current)
      return;
    const b = t.getState();
    let m, v;
    try {
      m = r(b, o.current);
    } catch (y) {
      v = y, d = y;
    }
    v || (d = null), m === i.current ? s.current || u() : (i.current = m, l.current = m, s.current = !0, p());
  };
  return n.onStateChange = f, n.trySubscribe(), f(), () => {
    if (a = !0, n.tryUnsubscribe(), n.onStateChange = null, d)
      throw d;
  };
}
function as(e, t) {
  return e === t;
}
let sr = !1;
function Zr(e, t, n, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: o = as,
  areOwnPropsEqual: i = Rt,
  areStatePropsEqual: s = Rt,
  areMergedPropsEqual: c = Rt,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: l = !1,
  // the context consumer to use
  context: u = qr
} = {}) {
  process.env.NODE_ENV !== "production" && r !== void 0 && !sr && (sr = !0, nn('The `pure` option has been removed. `connect` is now always a "pure/memoized" component'));
  const p = u, a = Ki(e), d = Yi(t), f = Zi(n), h = !!e;
  return (m) => {
    if (process.env.NODE_ENV !== "production" && !nr.isValidElementType(m))
      throw new Error(`You must pass a component to the function returned by connect. Instead received ${os(m)}`);
    const v = m.displayName || m.name || "Component", y = `Connect(${v})`, O = {
      shouldHandleStateChanges: h,
      displayName: y,
      wrappedComponentName: v,
      WrappedComponent: m,
      // @ts-ignore
      initMapStateToProps: a,
      // @ts-ignore
      initMapDispatchToProps: d,
      initMergeProps: f,
      areStatesEqual: o,
      areStatePropsEqual: s,
      areOwnPropsEqual: i,
      areMergedPropsEqual: c
    };
    function D(w) {
      const [_, H, B] = R.useMemo(() => {
        const {
          reactReduxForwardedRef: Z
        } = w, de = zr(w, ts);
        return [w.context, Z, de];
      }, [w]), k = R.useMemo(() => _ && _.Consumer && // @ts-ignore
      nr.isContextConsumer(/* @__PURE__ */ R.createElement(_.Consumer, null)) ? _ : p, [_, p]), $ = R.useContext(k), X = !!w.store && !!w.store.getState && !!w.store.dispatch, oe = !!$ && !!$.store;
      if (process.env.NODE_ENV !== "production" && !X && !oe)
        throw new Error(`Could not find "store" in the context of "${y}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${y} in connect options.`);
      const J = X ? w.store : $.store, he = oe ? $.getServerState : J.getState, Oe = R.useMemo(() => ji(J.dispatch, O), [J]), [ie, xe] = R.useMemo(() => {
        if (!h) return rs;
        const Z = Xr(J, X ? void 0 : $.subscription), de = Z.notifyNestedSubs.bind(Z);
        return [Z, de];
      }, [J, X, $]), Qe = R.useMemo(() => X ? $ : se({}, $, {
        subscription: ie
      }), [X, $, ie]), Ie = R.useRef(), we = R.useRef(B), ue = R.useRef(), et = R.useRef(!1);
      R.useRef(!1);
      const Ce = R.useRef(!1), _e = R.useRef();
      pt(() => (Ce.current = !0, () => {
        Ce.current = !1;
      }), []);
      const tt = R.useMemo(() => () => ue.current && B === we.current ? ue.current : Oe(J.getState(), B), [J, B]), Ot = R.useMemo(() => (de) => ie ? cs(
        h,
        J,
        ie,
        // @ts-ignore
        Oe,
        we,
        Ie,
        et,
        Ce,
        ue,
        xe,
        de
      ) : () => {
      }, [ie]);
      is(ss, [we, Ie, et, B, ue, xe]);
      let ve;
      try {
        ve = Jr(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          Ot,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          tt,
          he ? () => Oe(he(), B) : tt
        );
      } catch (Z) {
        throw _e.current && (Z.message += `
The error may be correlated with this previous error:
${_e.current.stack}

`), Z;
      }
      pt(() => {
        _e.current = void 0, ue.current = void 0, Ie.current = ve;
      });
      const Ae = R.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ R.createElement(m, se({}, ve, {
          ref: H
        }))
      ), [H, m, ve]);
      return R.useMemo(() => h ? /* @__PURE__ */ R.createElement(k.Provider, {
        value: Qe
      }, Ae) : Ae, [k, Ae, Qe]);
    }
    const E = R.memo(D);
    if (E.WrappedComponent = m, E.displayName = D.displayName = y, l) {
      const _ = R.forwardRef(function(B, k) {
        return /* @__PURE__ */ R.createElement(E, se({}, B, {
          reactReduxForwardedRef: k
        }));
      });
      return _.displayName = y, _.WrappedComponent = m, Zn(_, m);
    }
    return Zn(E, m);
  };
}
function ls({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: o = "once",
  noopCheck: i = "once"
}) {
  const s = R.useMemo(() => {
    const u = Xr(e);
    return {
      store: e,
      subscription: u,
      getServerState: r ? () => r : void 0,
      stabilityCheck: o,
      noopCheck: i
    };
  }, [e, r, o, i]), c = R.useMemo(() => e.getState(), [e]);
  pt(() => {
    const {
      subscription: u
    } = s;
    return u.onStateChange = u.notifyNestedSubs, u.trySubscribe(), c !== e.getState() && u.notifyNestedSubs(), () => {
      u.tryUnsubscribe(), u.onStateChange = void 0;
    };
  }, [s, c]);
  const l = t || qr;
  return /* @__PURE__ */ R.createElement(l.Provider, {
    value: s
  }, n);
}
ns(Ci.useSyncExternalStore);
Ti(di);
function us(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Qr(e, t) {
  var n = en(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], r = M(!0), o = M(n), i = r.current || !!(t && o.current.inputs && us(t, o.current.inputs)), s = i ? o.current : {
    inputs: t,
    result: e()
  };
  return re(function() {
    r.current = !1, o.current = s;
  }, [s]), s.result;
}
function ds(e, t) {
  return Qr(function() {
    return e;
  }, t);
}
var A = Qr, x = ds, ps = process.env.NODE_ENV === "production", Tt = "Invariant failed";
function cr(e, t) {
  if (ps)
    throw new Error(Tt);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(Tt, ": ").concat(n) : Tt;
  throw new Error(r);
}
var ne = function(t) {
  var n = t.top, r = t.right, o = t.bottom, i = t.left, s = r - i, c = o - n, l = {
    top: n,
    right: r,
    bottom: o,
    left: i,
    width: s,
    height: c,
    x: i,
    y: n,
    center: {
      x: (r + i) / 2,
      y: (o + n) / 2
    }
  };
  return l;
}, on = function(t, n) {
  return {
    top: t.top - n.top,
    left: t.left - n.left,
    bottom: t.bottom + n.bottom,
    right: t.right + n.right
  };
}, ar = function(t, n) {
  return {
    top: t.top + n.top,
    left: t.left + n.left,
    bottom: t.bottom - n.bottom,
    right: t.right - n.right
  };
}, fs = function(t, n) {
  return {
    top: t.top + n.y,
    left: t.left + n.x,
    bottom: t.bottom + n.y,
    right: t.right + n.x
  };
}, Lt = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, sn = function(t) {
  var n = t.borderBox, r = t.margin, o = r === void 0 ? Lt : r, i = t.border, s = i === void 0 ? Lt : i, c = t.padding, l = c === void 0 ? Lt : c, u = ne(on(n, o)), p = ne(ar(n, s)), a = ne(ar(p, l));
  return {
    marginBox: u,
    borderBox: ne(n),
    paddingBox: p,
    contentBox: a,
    margin: o,
    border: s,
    padding: l
  };
}, Q = function(t) {
  var n = t.slice(0, -2), r = t.slice(-2);
  if (r !== "px")
    return 0;
  var o = Number(n);
  return isNaN(o) && (process.env.NODE_ENV !== "production" ? cr(!1, "Could not parse value [raw: " + t + ", without suffix: " + n + "]") : cr()), o;
}, gs = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, ft = function(t, n) {
  var r = t.borderBox, o = t.border, i = t.margin, s = t.padding, c = fs(r, n);
  return sn({
    borderBox: c,
    border: o,
    margin: i,
    padding: s
  });
}, gt = function(t, n) {
  return n === void 0 && (n = gs()), ft(t, n);
}, eo = function(t, n) {
  var r = {
    top: Q(n.marginTop),
    right: Q(n.marginRight),
    bottom: Q(n.marginBottom),
    left: Q(n.marginLeft)
  }, o = {
    top: Q(n.paddingTop),
    right: Q(n.paddingRight),
    bottom: Q(n.paddingBottom),
    left: Q(n.paddingLeft)
  }, i = {
    top: Q(n.borderTopWidth),
    right: Q(n.borderRightWidth),
    bottom: Q(n.borderBottomWidth),
    left: Q(n.borderLeftWidth)
  };
  return sn({
    borderBox: t,
    margin: r,
    padding: o,
    border: i
  });
}, to = function(t) {
  var n = t.getBoundingClientRect(), r = window.getComputedStyle(t);
  return eo(n, r);
}, lr = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function ms(e, t) {
  return !!(e === t || lr(e) && lr(t));
}
function bs(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!ms(e[n], t[n]))
      return !1;
  return !0;
}
function G(e, t) {
  t === void 0 && (t = bs);
  var n = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, o);
    return n = {
      lastResult: s,
      lastArgs: o,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
var $e = function(t) {
  var n = [], r = null, o = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    n = c, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return o.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, o;
};
const hs = process.env.NODE_ENV === "production", vs = /[ \t]{2,}/g, ys = /^[ \t]*/gm, ur = (e) => e.replace(vs, " ").replace(ys, "").trim(), Es = (e) => ur(`
  %c@hello-pangea/dnd

  %c${ur(e)}

  %c👷‍ This is a development only message. It will be removed in production builds.
`), Ds = (e) => [Es(e), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"], Ns = "__@hello-pangea/dnd-disable-dev-warnings";
function no(e, t) {
  hs || typeof window != "undefined" && window[Ns] || console[e](...Ds(t));
}
const V = no.bind(null, "warn"), zt = no.bind(null, "error");
function ce() {
}
function Ss(e, t) {
  return N(N({}, e), t);
}
function ee(e, t, n) {
  const r = t.map((o) => {
    const i = Ss(n, o.options);
    return e.addEventListener(o.eventName, o.fn, i), function() {
      e.removeEventListener(o.eventName, o.fn, i);
    };
  });
  return function() {
    r.forEach((i) => {
      i();
    });
  };
}
const Os = process.env.NODE_ENV === "production", dr = "Invariant failed";
class Ge extends Error {
}
Ge.prototype.toString = function() {
  return this.message;
};
function g(e, t) {
  throw Os ? new Ge(dr) : new Ge(`${dr}: ${t || ""}`);
}
class xs extends P.Component {
  constructor(...t) {
    super(...t), this.callbacks = null, this.unbind = ce, this.onWindowError = (n) => {
      const r = this.getCallbacks();
      r.isDragging() && (r.tryAbort(), process.env.NODE_ENV !== "production" && V(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      const o = n.error;
      o instanceof Ge && (n.preventDefault(), process.env.NODE_ENV !== "production" && zt(o.message));
    }, this.getCallbacks = () => {
      if (!this.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return this.callbacks;
    }, this.setCallbacks = (n) => {
      this.callbacks = n;
    };
  }
  componentDidMount() {
    this.unbind = ee(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }
  componentDidCatch(t) {
    if (t instanceof Ge) {
      process.env.NODE_ENV !== "production" && zt(t.message), this.setState({});
      return;
    }
    throw t;
  }
  componentWillUnmount() {
    this.unbind();
  }
  render() {
    return this.props.children(this.setCallbacks);
  }
}
const Is = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, mt = (e) => e + 1, ws = (e) => `
  You have lifted an item in position ${mt(e.source.index)}
`, ro = (e, t) => {
  const n = e.droppableId === t.droppableId, r = mt(e.index), o = mt(t.index);
  return n ? `
      You have moved the item from position ${r}
      to position ${o}
    ` : `
    You have moved the item from position ${r}
    in list ${e.droppableId}
    to list ${t.droppableId}
    in position ${o}
  `;
}, oo = (e, t, n) => t.droppableId === n.droppableId ? `
      The item ${e}
      has been combined with ${n.draggableId}` : `
      The item ${e}
      in list ${t.droppableId}
      has been combined with ${n.draggableId}
      in list ${n.droppableId}
    `, Cs = (e) => {
  const t = e.destination;
  if (t)
    return ro(e.source, t);
  const n = e.combine;
  return n ? oo(e.draggableId, e.source, n) : "You are over an area that cannot be dropped on";
}, pr = (e) => `
  The item has returned to its starting position
  of ${mt(e.index)}
`, _s = (e) => {
  if (e.reason === "CANCEL")
    return `
      Movement cancelled.
      ${pr(e.source)}
    `;
  const t = e.destination, n = e.combine;
  return t ? `
      You have dropped the item.
      ${ro(e.source, t)}
    ` : n ? `
      You have dropped the item.
      ${oo(e.draggableId, e.source, n)}
    ` : `
    The item has been dropped while not over a drop area.
    ${pr(e.source)}
  `;
}, As = {
  dragHandleUsageInstructions: Is,
  onDragStart: ws,
  onDragUpdate: Cs,
  onDragEnd: _s
};
var dt = As;
const F = {
  x: 0,
  y: 0
}, W = (e, t) => ({
  x: e.x + t.x,
  y: e.y + t.y
}), z = (e, t) => ({
  x: e.x - t.x,
  y: e.y - t.y
}), ae = (e, t) => e.x === t.x && e.y === t.y, Ne = (e) => ({
  x: e.x !== 0 ? -e.x : 0,
  y: e.y !== 0 ? -e.y : 0
}), me = (e, t, n = 0) => e === "x" ? {
  x: t,
  y: n
} : {
  x: n,
  y: t
}, Fe = (e, t) => Math.sqrt(rt(t.x - e.x, 2) + rt(t.y - e.y, 2)), fr = (e, t) => Math.min(...t.map((n) => Fe(e, n))), io = (e) => (t) => ({
  x: e(t.x),
  y: e(t.y)
});
var Ps = (e, t) => {
  const n = ne({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return n.width <= 0 || n.height <= 0 ? null : n;
};
const ze = (e, t) => ({
  top: e.top + t.y,
  left: e.left + t.x,
  bottom: e.bottom + t.y,
  right: e.right + t.x
}), gr = (e) => [{
  x: e.left,
  y: e.top
}, {
  x: e.right,
  y: e.top
}, {
  x: e.left,
  y: e.bottom
}, {
  x: e.right,
  y: e.bottom
}], Rs = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, Ts = (e, t) => t ? ze(e, t.scroll.diff.displacement) : e, Ls = (e, t, n) => n && n.increasedBy ? C(N({}, e), {
  [t.end]: e[t.end] + n.increasedBy[t.line]
}) : e, Bs = (e, t) => t && t.shouldClipSubject ? Ps(t.pageMarginBox, e) : ne(e);
var ye = ({
  page: e,
  withPlaceholder: t,
  axis: n,
  frame: r
}) => {
  const o = Ts(e.marginBox, r), i = Ls(o, n, t), s = Bs(i, r);
  return {
    page: e,
    withPlaceholder: t,
    active: s
  };
}, cn = (e, t) => {
  e.frame || (process.env.NODE_ENV, g());
  const n = e.frame, r = z(t, n.scroll.initial), o = Ne(r), i = C(N({}, n), {
    scroll: {
      initial: n.scroll.initial,
      current: t,
      diff: {
        value: r,
        displacement: o
      },
      max: n.scroll.max
    }
  }), s = ye({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: i
  });
  return C(N({}, e), {
    frame: i,
    subject: s
  });
};
const so = G((e) => e.reduce((t, n) => (t[n.descriptor.id] = n, t), {})), co = G((e) => e.reduce((t, n) => (t[n.descriptor.id] = n, t), {})), vt = G((e) => Object.values(e)), Vs = G((e) => Object.values(e));
var be = G((e, t) => Vs(t).filter((r) => e === r.descriptor.droppableId).sort((r, o) => r.descriptor.index - o.descriptor.index));
function an(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function yt(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var Et = G((e, t) => t.filter((n) => n.descriptor.id !== e.descriptor.id)), Ms = ({
  isMovingForward: e,
  draggable: t,
  destination: n,
  insideDestination: r,
  previousImpact: o
}) => {
  if (!n.isCombineEnabled || !an(o))
    return null;
  function s(f) {
    const h = {
      type: "COMBINE",
      combine: {
        draggableId: f,
        droppableId: n.descriptor.id
      }
    };
    return C(N({}, o), {
      at: h
    });
  }
  const c = o.displaced.all, l = c.length ? c[0] : null;
  if (e)
    return l ? s(l) : null;
  const u = Et(t, r);
  if (!l) {
    if (!u.length)
      return null;
    const f = u[u.length - 1];
    return s(f.descriptor.id);
  }
  const p = u.findIndex((f) => f.descriptor.id === l);
  p === -1 && (process.env.NODE_ENV !== "production" ? g(!1, "Could not find displaced item in set") : g());
  const a = p - 1;
  if (a < 0)
    return null;
  const d = u[a];
  return s(d.descriptor.id);
}, Se = (e, t) => e.descriptor.droppableId === t.descriptor.id;
const ao = {
  point: F,
  value: 0
}, We = {
  invisible: {},
  visible: {},
  all: []
}, $s = {
  displaced: We,
  displacedBy: ao,
  at: null
};
var Gs = $s, te = (e, t) => (n) => e <= n && n <= t, lo = (e) => {
  const t = te(e.top, e.bottom), n = te(e.left, e.right);
  return (r) => {
    if (t(r.top) && t(r.bottom) && n(r.left) && n(r.right))
      return !0;
    const i = t(r.top) || t(r.bottom), s = n(r.left) || n(r.right);
    if (i && s)
      return !0;
    const l = r.top < e.top && r.bottom > e.bottom, u = r.left < e.left && r.right > e.right;
    return l && u ? !0 : l && s || u && i;
  };
}, Fs = (e) => {
  const t = te(e.top, e.bottom), n = te(e.left, e.right);
  return (r) => t(r.top) && t(r.bottom) && n(r.left) && n(r.right);
};
const ln = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, uo = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
};
var Ws = (e) => (t) => {
  const n = te(t.top, t.bottom), r = te(t.left, t.right);
  return (o) => e === ln ? n(o.top) && n(o.bottom) : r(o.left) && r(o.right);
};
const Us = (e, t) => {
  const n = t.frame ? t.frame.scroll.diff.displacement : F;
  return ze(e, n);
}, Hs = (e, t, n) => t.subject.active ? n(t.subject.active)(e) : !1, ks = (e, t, n) => n(t)(e), un = ({
  target: e,
  destination: t,
  viewport: n,
  withDroppableDisplacement: r,
  isVisibleThroughFrameFn: o
}) => {
  const i = r ? Us(e, t) : e;
  return Hs(i, t, o) && ks(i, n, o);
}, js = (e) => un(C(N({}, e), {
  isVisibleThroughFrameFn: lo
})), po = (e) => un(C(N({}, e), {
  isVisibleThroughFrameFn: Fs
})), qs = (e) => un(C(N({}, e), {
  isVisibleThroughFrameFn: Ws(e.destination.axis)
})), zs = (e, t, n) => {
  if (typeof n == "boolean")
    return n;
  if (!t)
    return !0;
  const {
    invisible: r,
    visible: o
  } = t;
  if (r[e])
    return !1;
  const i = o[e];
  return i ? i.shouldAnimate : !0;
};
function Ys(e, t) {
  const n = e.page.marginBox, r = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return ne(on(n, r));
}
function Ue({
  afterDragging: e,
  destination: t,
  displacedBy: n,
  viewport: r,
  forceShouldAnimate: o,
  last: i
}) {
  return e.reduce(function(c, l) {
    const u = Ys(l, n), p = l.descriptor.id;
    if (c.all.push(p), !js({
      target: u,
      destination: t,
      viewport: r,
      withDroppableDisplacement: !0
    }))
      return c.invisible[l.descriptor.id] = !0, c;
    const d = zs(p, i, o), f = {
      draggableId: p,
      shouldAnimate: d
    };
    return c.visible[p] = f, c;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function Ks(e, t) {
  if (!e.length)
    return 0;
  const n = e[e.length - 1].descriptor.index;
  return t.inHomeList ? n : n + 1;
}
function mr({
  insideDestination: e,
  inHomeList: t,
  displacedBy: n,
  destination: r
}) {
  const o = Ks(e, {
    inHomeList: t
  });
  return {
    displaced: We,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: r.descriptor.id,
        index: o
      }
    }
  };
}
function bt({
  draggable: e,
  insideDestination: t,
  destination: n,
  viewport: r,
  displacedBy: o,
  last: i,
  index: s,
  forceShouldAnimate: c
}) {
  const l = Se(e, n);
  if (s == null)
    return mr({
      insideDestination: t,
      inHomeList: l,
      displacedBy: o,
      destination: n
    });
  const u = t.find((h) => h.descriptor.index === s);
  if (!u)
    return mr({
      insideDestination: t,
      inHomeList: l,
      displacedBy: o,
      destination: n
    });
  const p = Et(e, t), a = t.indexOf(u), d = p.slice(a);
  return {
    displaced: Ue({
      afterDragging: d,
      destination: n,
      displacedBy: o,
      last: i,
      viewport: r.frame,
      forceShouldAnimate: c
    }),
    displacedBy: o,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function le(e, t) {
  return !!t.effected[e];
}
var Xs = ({
  isMovingForward: e,
  destination: t,
  draggables: n,
  combine: r,
  afterCritical: o
}) => {
  if (!t.isCombineEnabled)
    return null;
  const i = r.draggableId, c = n[i].descriptor.index;
  return le(i, o) ? e ? c : c - 1 : e ? c + 1 : c;
}, Js = ({
  isMovingForward: e,
  isInHomeList: t,
  insideDestination: n,
  location: r
}) => {
  if (!n.length)
    return null;
  const o = r.index, i = e ? o + 1 : o - 1, s = n[0].descriptor.index, c = n[n.length - 1].descriptor.index, l = t ? c : c + 1;
  return i < s || i > l ? null : i;
}, Zs = ({
  isMovingForward: e,
  isInHomeList: t,
  draggable: n,
  draggables: r,
  destination: o,
  insideDestination: i,
  previousImpact: s,
  viewport: c,
  afterCritical: l
}) => {
  const u = s.at;
  if (u || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot move in direction without previous impact location") : g()), u.type === "REORDER") {
    const a = Js({
      isMovingForward: e,
      isInHomeList: t,
      location: u.destination,
      insideDestination: i
    });
    return a == null ? null : bt({
      draggable: n,
      insideDestination: i,
      destination: o,
      viewport: c,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: a
    });
  }
  const p = Xs({
    isMovingForward: e,
    destination: o,
    displaced: s.displaced,
    draggables: r,
    combine: u.combine,
    afterCritical: l
  });
  return p == null ? null : bt({
    draggable: n,
    insideDestination: i,
    destination: o,
    viewport: c,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: p
  });
}, Qs = ({
  displaced: e,
  afterCritical: t,
  combineWith: n,
  displacedBy: r
}) => {
  const o = !!(e.visible[n] || e.invisible[n]);
  return le(n, t) ? o ? F : Ne(r.point) : o ? r.point : F;
}, ec = ({
  afterCritical: e,
  impact: t,
  draggables: n
}) => {
  const r = yt(t);
  r || (process.env.NODE_ENV, g());
  const o = r.draggableId, i = n[o].page.borderBox.center, s = Qs({
    displaced: t.displaced,
    afterCritical: e,
    combineWith: o,
    displacedBy: t.displacedBy
  });
  return W(i, s);
};
const fo = (e, t) => t.margin[e.start] + t.borderBox[e.size] / 2, tc = (e, t) => t.margin[e.end] + t.borderBox[e.size] / 2, dn = (e, t, n) => t[e.crossAxisStart] + n.margin[e.crossAxisStart] + n.borderBox[e.crossAxisSize] / 2, br = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: n
}) => me(e.line, t.marginBox[e.end] + fo(e, n), dn(e, t.marginBox, n)), hr = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: n
}) => me(e.line, t.marginBox[e.start] - tc(e, n), dn(e, t.marginBox, n)), nc = ({
  axis: e,
  moveInto: t,
  isMoving: n
}) => me(e.line, t.contentBox[e.start] + fo(e, n), dn(e, t.contentBox, n));
var rc = ({
  impact: e,
  draggable: t,
  draggables: n,
  droppable: r,
  afterCritical: o
}) => {
  const i = be(r.descriptor.id, n), s = t.page, c = r.axis;
  if (!i.length)
    return nc({
      axis: c,
      moveInto: r.page,
      isMoving: s
    });
  const {
    displaced: l,
    displacedBy: u
  } = e, p = l.all[0];
  if (p) {
    const d = n[p];
    if (le(p, o))
      return hr({
        axis: c,
        moveRelativeTo: d.page,
        isMoving: s
      });
    const f = ft(d.page, u.point);
    return hr({
      axis: c,
      moveRelativeTo: f,
      isMoving: s
    });
  }
  const a = i[i.length - 1];
  if (a.descriptor.id === t.descriptor.id)
    return s.borderBox.center;
  if (le(a.descriptor.id, o)) {
    const d = ft(a.page, Ne(o.displacedBy.point));
    return br({
      axis: c,
      moveRelativeTo: d,
      isMoving: s
    });
  }
  return br({
    axis: c,
    moveRelativeTo: a.page,
    isMoving: s
  });
}, Yt = (e, t) => {
  const n = e.frame;
  return n ? W(t, n.scroll.diff.displacement) : t;
};
const oc = ({
  impact: e,
  draggable: t,
  droppable: n,
  draggables: r,
  afterCritical: o
}) => {
  const i = t.page.borderBox.center, s = e.at;
  return !n || !s ? i : s.type === "REORDER" ? rc({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: n,
    afterCritical: o
  }) : ec({
    impact: e,
    draggables: r,
    afterCritical: o
  });
};
var Dt = (e) => {
  const t = oc(e), n = e.droppable;
  return n ? Yt(n, t) : t;
}, go = (e, t) => {
  const n = z(t, e.scroll.initial), r = Ne(n);
  return {
    frame: ne({
      top: t.y,
      bottom: t.y + e.frame.height,
      left: t.x,
      right: t.x + e.frame.width
    }),
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: n,
        displacement: r
      }
    }
  };
};
function vr(e, t) {
  return e.map((n) => t[n]);
}
function ic(e, t) {
  for (let n = 0; n < t.length; n++) {
    const r = t[n].visible[e];
    if (r)
      return r;
  }
  return null;
}
var sc = ({
  impact: e,
  viewport: t,
  destination: n,
  draggables: r,
  maxScrollChange: o
}) => {
  const i = go(t, W(t.scroll.current, o)), s = n.frame ? cn(n, W(n.frame.scroll.current, o)) : n, c = e.displaced, l = Ue({
    afterDragging: vr(c.all, r),
    destination: n,
    displacedBy: e.displacedBy,
    viewport: i.frame,
    last: c,
    forceShouldAnimate: !1
  }), u = Ue({
    afterDragging: vr(c.all, r),
    destination: s,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    last: c,
    forceShouldAnimate: !1
  }), p = {}, a = {}, d = [c, l, u];
  return c.all.forEach((h) => {
    const b = ic(h, d);
    if (b) {
      a[h] = b;
      return;
    }
    p[h] = !0;
  }), C(N({}, e), {
    displaced: {
      all: c.all,
      invisible: p,
      visible: a
    }
  });
}, cc = (e, t) => W(e.scroll.diff.displacement, t), pn = ({
  pageBorderBoxCenter: e,
  draggable: t,
  viewport: n
}) => {
  const r = cc(n, e), o = z(r, t.page.borderBox.center);
  return W(t.client.borderBox.center, o);
}, mo = ({
  draggable: e,
  destination: t,
  newPageBorderBoxCenter: n,
  viewport: r,
  withDroppableDisplacement: o,
  onlyOnMainAxis: i = !1
}) => {
  const s = z(n, e.page.borderBox.center), l = {
    target: ze(e.page.borderBox, s),
    destination: t,
    withDroppableDisplacement: o,
    viewport: r
  };
  return i ? qs(l) : po(l);
}, ac = ({
  isMovingForward: e,
  draggable: t,
  destination: n,
  draggables: r,
  previousImpact: o,
  viewport: i,
  previousPageBorderBoxCenter: s,
  previousClientSelection: c,
  afterCritical: l
}) => {
  if (!n.isEnabled)
    return null;
  const u = be(n.descriptor.id, r), p = Se(t, n), a = Ms({
    isMovingForward: e,
    draggable: t,
    destination: n,
    insideDestination: u,
    previousImpact: o
  }) || Zs({
    isMovingForward: e,
    isInHomeList: p,
    draggable: t,
    draggables: r,
    destination: n,
    insideDestination: u,
    previousImpact: o,
    viewport: i,
    afterCritical: l
  });
  if (!a)
    return null;
  const d = Dt({
    impact: a,
    draggable: t,
    droppable: n,
    draggables: r,
    afterCritical: l
  });
  if (mo({
    draggable: t,
    destination: n,
    newPageBorderBoxCenter: d,
    viewport: i.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  }))
    return {
      clientSelection: pn({
        pageBorderBoxCenter: d,
        draggable: t,
        viewport: i
      }),
      impact: a,
      scrollJumpRequest: null
    };
  const h = z(d, s), b = sc({
    impact: a,
    viewport: i,
    destination: n,
    draggables: r,
    maxScrollChange: h
  });
  return {
    clientSelection: c,
    impact: b,
    scrollJumpRequest: h
  };
};
const j = (e) => {
  const t = e.subject.active;
  return t || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot get clipped area from droppable") : g()), t;
};
var lc = ({
  isMovingForward: e,
  pageBorderBoxCenter: t,
  source: n,
  droppables: r,
  viewport: o
}) => {
  const i = n.subject.active;
  if (!i)
    return null;
  const s = n.axis, c = te(i[s.start], i[s.end]), l = vt(r).filter((p) => p !== n).filter((p) => p.isEnabled).filter((p) => !!p.subject.active).filter((p) => lo(o.frame)(j(p))).filter((p) => {
    const a = j(p);
    return e ? i[s.crossAxisEnd] < a[s.crossAxisEnd] : a[s.crossAxisStart] < i[s.crossAxisStart];
  }).filter((p) => {
    const a = j(p), d = te(a[s.start], a[s.end]);
    return c(a[s.start]) || c(a[s.end]) || d(i[s.start]) || d(i[s.end]);
  }).sort((p, a) => {
    const d = j(p)[s.crossAxisStart], f = j(a)[s.crossAxisStart];
    return e ? d - f : f - d;
  }).filter((p, a, d) => j(p)[s.crossAxisStart] === j(d[0])[s.crossAxisStart]);
  if (!l.length)
    return null;
  if (l.length === 1)
    return l[0];
  const u = l.filter((p) => te(j(p)[s.start], j(p)[s.end])(t[s.line]));
  return u.length === 1 ? u[0] : u.length > 1 ? u.sort((p, a) => j(p)[s.start] - j(a)[s.start])[0] : l.sort((p, a) => {
    const d = fr(t, gr(j(p))), f = fr(t, gr(j(a)));
    return d !== f ? d - f : j(p)[s.start] - j(a)[s.start];
  })[0];
};
const yr = (e, t) => {
  const n = e.page.borderBox.center;
  return le(e.descriptor.id, t) ? z(n, t.displacedBy.point) : n;
}, uc = (e, t) => {
  const n = e.page.borderBox;
  return le(e.descriptor.id, t) ? ze(n, Ne(t.displacedBy.point)) : n;
};
var dc = ({
  pageBorderBoxCenter: e,
  viewport: t,
  destination: n,
  insideDestination: r,
  afterCritical: o
}) => r.filter((s) => po({
  target: uc(s, o),
  destination: n,
  viewport: t.frame,
  withDroppableDisplacement: !0
})).sort((s, c) => {
  const l = Fe(e, Yt(n, yr(s, o))), u = Fe(e, Yt(n, yr(c, o)));
  return l < u ? -1 : u < l ? 1 : s.descriptor.index - c.descriptor.index;
})[0] || null, Ye = G(function(t, n) {
  const r = n[t.line];
  return {
    value: r,
    point: me(t.line, r)
  };
});
const pc = (e, t, n) => {
  const r = e.axis;
  if (e.descriptor.mode === "virtual")
    return me(r.line, t[r.line]);
  const o = e.subject.page.contentBox[r.size], l = be(e.descriptor.id, n).reduce((u, p) => u + p.client.marginBox[r.size], 0) + t[r.line] - o;
  return l <= 0 ? null : me(r.line, l);
}, bo = (e, t) => C(N({}, e), {
  scroll: C(N({}, e.scroll), {
    max: t
  })
}), ho = (e, t, n) => {
  const r = e.frame;
  Se(t, e) && (process.env.NODE_ENV !== "production" ? g(!1, "Should not add placeholder space to home list") : g()), e.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot add placeholder size to a subject when it already has one") : g());
  const o = Ye(e.axis, t.displaceBy).point, i = pc(e, o, n), s = {
    placeholderSize: o,
    increasedBy: i,
    oldFrameMaxScroll: e.frame ? e.frame.scroll.max : null
  };
  if (!r) {
    const p = ye({
      page: e.subject.page,
      withPlaceholder: s,
      axis: e.axis,
      frame: e.frame
    });
    return C(N({}, e), {
      subject: p
    });
  }
  const c = i ? W(r.scroll.max, i) : r.scroll.max, l = bo(r, c), u = ye({
    page: e.subject.page,
    withPlaceholder: s,
    axis: e.axis,
    frame: l
  });
  return C(N({}, e), {
    subject: u,
    frame: l
  });
}, fc = (e) => {
  const t = e.subject.withPlaceholder;
  t || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot remove placeholder form subject when there was none") : g());
  const n = e.frame;
  if (!n) {
    const s = ye({
      page: e.subject.page,
      axis: e.axis,
      frame: null,
      withPlaceholder: null
    });
    return C(N({}, e), {
      subject: s
    });
  }
  const r = t.oldFrameMaxScroll;
  r || (process.env.NODE_ENV !== "production" ? g(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : g());
  const o = bo(n, r), i = ye({
    page: e.subject.page,
    axis: e.axis,
    frame: o,
    withPlaceholder: null
  });
  return C(N({}, e), {
    subject: i,
    frame: o
  });
};
var gc = ({
  previousPageBorderBoxCenter: e,
  moveRelativeTo: t,
  insideDestination: n,
  draggable: r,
  draggables: o,
  destination: i,
  viewport: s,
  afterCritical: c
}) => {
  if (!t) {
    if (n.length)
      return null;
    const a = {
      displaced: We,
      displacedBy: ao,
      at: {
        type: "REORDER",
        destination: {
          droppableId: i.descriptor.id,
          index: 0
        }
      }
    }, d = Dt({
      impact: a,
      draggable: r,
      droppable: i,
      draggables: o,
      afterCritical: c
    }), f = Se(r, i) ? i : ho(i, r, o);
    return mo({
      draggable: r,
      destination: f,
      newPageBorderBoxCenter: d,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    }) ? a : null;
  }
  const l = e[i.axis.line] <= t.page.borderBox.center[i.axis.line], u = (() => {
    const a = t.descriptor.index;
    return t.descriptor.id === r.descriptor.id || l ? a : a + 1;
  })(), p = Ye(i.axis, r.displaceBy);
  return bt({
    draggable: r,
    insideDestination: n,
    destination: i,
    viewport: s,
    displacedBy: p,
    last: We,
    index: u
  });
}, mc = ({
  isMovingForward: e,
  previousPageBorderBoxCenter: t,
  draggable: n,
  isOver: r,
  draggables: o,
  droppables: i,
  viewport: s,
  afterCritical: c
}) => {
  const l = lc({
    isMovingForward: e,
    pageBorderBoxCenter: t,
    source: r,
    droppables: i,
    viewport: s
  });
  if (!l)
    return null;
  const u = be(l.descriptor.id, o), p = dc({
    pageBorderBoxCenter: t,
    viewport: s,
    destination: l,
    insideDestination: u,
    afterCritical: c
  }), a = gc({
    previousPageBorderBoxCenter: t,
    destination: l,
    draggable: n,
    draggables: o,
    moveRelativeTo: p,
    insideDestination: u,
    viewport: s,
    afterCritical: c
  });
  if (!a)
    return null;
  const d = Dt({
    impact: a,
    draggable: n,
    droppable: l,
    draggables: o,
    afterCritical: c
  });
  return {
    clientSelection: pn({
      pageBorderBoxCenter: d,
      draggable: n,
      viewport: s
    }),
    impact: a,
    scrollJumpRequest: null
  };
}, Y = (e) => {
  const t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
};
const bc = (e, t) => {
  const n = Y(e);
  return n ? t[n] : null;
};
var hc = ({
  state: e,
  type: t
}) => {
  const n = bc(e.impact, e.dimensions.droppables), r = !!n, o = e.dimensions.droppables[e.critical.droppable.id], i = n || o, s = i.axis.direction, c = s === "vertical" && (t === "MOVE_UP" || t === "MOVE_DOWN") || s === "horizontal" && (t === "MOVE_LEFT" || t === "MOVE_RIGHT");
  if (c && !r)
    return null;
  const l = t === "MOVE_DOWN" || t === "MOVE_RIGHT", u = e.dimensions.draggables[e.critical.draggable.id], p = e.current.page.borderBoxCenter, {
    draggables: a,
    droppables: d
  } = e.dimensions;
  return c ? ac({
    isMovingForward: l,
    previousPageBorderBoxCenter: p,
    draggable: u,
    destination: i,
    draggables: a,
    viewport: e.viewport,
    previousClientSelection: e.current.client.selection,
    previousImpact: e.impact,
    afterCritical: e.afterCritical
  }) : mc({
    isMovingForward: l,
    previousPageBorderBoxCenter: p,
    draggable: u,
    isOver: i,
    draggables: a,
    droppables: d,
    viewport: e.viewport,
    afterCritical: e.afterCritical
  });
};
function ge(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function vo(e) {
  const t = te(e.top, e.bottom), n = te(e.left, e.right);
  return function(o) {
    return t(o.y) && n(o.x);
  };
}
function vc(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function yc({
  pageBorderBox: e,
  draggable: t,
  candidates: n
}) {
  const r = t.page.borderBox.center, o = n.map((i) => {
    const s = i.axis, c = me(i.axis.line, e.center[s.line], i.page.borderBox.center[s.crossAxisLine]);
    return {
      id: i.descriptor.id,
      distance: Fe(r, c)
    };
  }).sort((i, s) => s.distance - i.distance);
  return o[0] ? o[0].id : null;
}
function Ec({
  pageBorderBox: e,
  draggable: t,
  droppables: n
}) {
  const r = vt(n).filter((o) => {
    if (!o.isEnabled)
      return !1;
    const i = o.subject.active;
    if (!i || !vc(e, i))
      return !1;
    if (vo(i)(e.center))
      return !0;
    const s = o.axis, c = i.center[s.crossAxisLine], l = e[s.crossAxisStart], u = e[s.crossAxisEnd], p = te(i[s.crossAxisStart], i[s.crossAxisEnd]), a = p(l), d = p(u);
    return !a && !d ? !0 : a ? l < c : u > c;
  });
  return r.length ? r.length === 1 ? r[0].descriptor.id : yc({
    pageBorderBox: e,
    draggable: t,
    candidates: r
  }) : null;
}
const yo = (e, t) => ne(ze(e, t));
var Dc = (e, t) => {
  const n = e.frame;
  return n ? yo(t, n.scroll.diff.value) : t;
};
function Eo({
  displaced: e,
  id: t
}) {
  return !!(e.visible[t] || e.invisible[t]);
}
function Nc({
  draggable: e,
  closest: t,
  inHomeList: n
}) {
  return t ? n && t.descriptor.index > e.descriptor.index ? t.descriptor.index - 1 : t.descriptor.index : null;
}
var Sc = ({
  pageBorderBoxWithDroppableScroll: e,
  draggable: t,
  destination: n,
  insideDestination: r,
  last: o,
  viewport: i,
  afterCritical: s
}) => {
  const c = n.axis, l = Ye(n.axis, t.displaceBy), u = l.value, p = e[c.start], a = e[c.end], f = Et(t, r).find((b) => {
    const m = b.descriptor.id, v = b.page.borderBox.center[c.line], y = le(m, s), O = Eo({
      displaced: o,
      id: m
    });
    return y ? O ? a <= v : p < v - u : O ? a <= v + u : p < v;
  }) || null, h = Nc({
    draggable: t,
    closest: f,
    inHomeList: Se(t, n)
  });
  return bt({
    draggable: t,
    insideDestination: r,
    destination: n,
    viewport: i,
    last: o,
    displacedBy: l,
    index: h
  });
};
const Oc = 4;
var xc = ({
  draggable: e,
  pageBorderBoxWithDroppableScroll: t,
  previousImpact: n,
  destination: r,
  insideDestination: o,
  afterCritical: i
}) => {
  if (!r.isCombineEnabled)
    return null;
  const s = r.axis, c = Ye(r.axis, e.displaceBy), l = c.value, u = t[s.start], p = t[s.end], d = Et(e, o).find((h) => {
    const b = h.descriptor.id, m = h.page.borderBox, y = m[s.size] / Oc, O = le(b, i), D = Eo({
      displaced: n.displaced,
      id: b
    });
    return O ? D ? p > m[s.start] + y && p < m[s.end] - y : u > m[s.start] - l + y && u < m[s.end] - l - y : D ? p > m[s.start] + l + y && p < m[s.end] + l - y : u > m[s.start] + y && u < m[s.end] - y;
  });
  return d ? {
    displacedBy: c,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: d.descriptor.id,
        droppableId: r.descriptor.id
      }
    }
  } : null;
}, Do = ({
  pageOffset: e,
  draggable: t,
  draggables: n,
  droppables: r,
  previousImpact: o,
  viewport: i,
  afterCritical: s
}) => {
  const c = yo(t.page.borderBox, e), l = Ec({
    pageBorderBox: c,
    draggable: t,
    droppables: r
  });
  if (!l)
    return Gs;
  const u = r[l], p = be(u.descriptor.id, n), a = Dc(u, c);
  return xc({
    pageBorderBoxWithDroppableScroll: a,
    draggable: t,
    previousImpact: o,
    destination: u,
    insideDestination: p,
    afterCritical: s
  }) || Sc({
    pageBorderBoxWithDroppableScroll: a,
    draggable: t,
    destination: u,
    insideDestination: p,
    last: o.displaced,
    viewport: i,
    afterCritical: s
  });
}, fn = (e, t) => C(N({}, e), {
  [t.descriptor.id]: t
});
const Ic = ({
  previousImpact: e,
  impact: t,
  droppables: n
}) => {
  const r = Y(e), o = Y(t);
  if (!r || r === o)
    return n;
  const i = n[r];
  if (!i.subject.withPlaceholder)
    return n;
  const s = fc(i);
  return fn(n, s);
};
var wc = ({
  draggable: e,
  draggables: t,
  droppables: n,
  previousImpact: r,
  impact: o
}) => {
  const i = Ic({
    previousImpact: r,
    impact: o,
    droppables: n
  }), s = Y(o);
  if (!s)
    return i;
  const c = n[s];
  if (Se(e, c) || c.subject.withPlaceholder)
    return i;
  const l = ho(c, e, t);
  return fn(i, l);
}, Be = ({
  state: e,
  clientSelection: t,
  dimensions: n,
  viewport: r,
  impact: o,
  scrollJumpRequest: i
}) => {
  const s = r || e.viewport, c = n || e.dimensions, l = t || e.current.client.selection, u = z(l, e.initial.client.selection), p = {
    offset: u,
    selection: l,
    borderBoxCenter: W(e.initial.client.borderBoxCenter, u)
  }, a = {
    selection: W(p.selection, s.scroll.current),
    borderBoxCenter: W(p.borderBoxCenter, s.scroll.current),
    offset: W(p.offset, s.scroll.diff.value)
  }, d = {
    client: p,
    page: a
  };
  if (e.phase === "COLLECTING")
    return C(N({}, e), {
      dimensions: c,
      viewport: s,
      current: d
    });
  const f = c.draggables[e.critical.draggable.id], h = o || Do({
    pageOffset: a.offset,
    draggable: f,
    draggables: c.draggables,
    droppables: c.droppables,
    previousImpact: e.impact,
    viewport: s,
    afterCritical: e.afterCritical
  }), b = wc({
    draggable: f,
    impact: h,
    previousImpact: e.impact,
    draggables: c.draggables,
    droppables: c.droppables
  });
  return C(N({}, e), {
    current: d,
    dimensions: {
      draggables: c.draggables,
      droppables: b
    },
    impact: h,
    viewport: s,
    scrollJumpRequest: i || null,
    forceShouldAnimate: i ? !1 : null
  });
};
function Cc(e, t) {
  return e.map((n) => t[n]);
}
var No = ({
  impact: e,
  viewport: t,
  draggables: n,
  destination: r,
  forceShouldAnimate: o
}) => {
  const i = e.displaced, s = Cc(i.all, n), c = Ue({
    afterDragging: s,
    destination: r,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    forceShouldAnimate: o,
    last: i
  });
  return C(N({}, e), {
    displaced: c
  });
}, So = ({
  impact: e,
  draggable: t,
  droppable: n,
  draggables: r,
  viewport: o,
  afterCritical: i
}) => {
  const s = Dt({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: n,
    afterCritical: i
  });
  return pn({
    pageBorderBoxCenter: s,
    draggable: t,
    viewport: o
  });
}, Oo = ({
  state: e,
  dimensions: t,
  viewport: n
}) => {
  e.movementMode !== "SNAP" && (process.env.NODE_ENV, g());
  const r = e.impact, o = n || e.viewport, i = t || e.dimensions, {
    draggables: s,
    droppables: c
  } = i, l = s[e.critical.draggable.id], u = Y(r);
  u || (process.env.NODE_ENV !== "production" ? g(!1, "Must be over a destination in SNAP movement mode") : g());
  const p = c[u], a = No({
    impact: r,
    viewport: o,
    destination: p,
    draggables: s
  }), d = So({
    impact: a,
    draggable: l,
    droppable: p,
    draggables: s,
    viewport: o,
    afterCritical: e.afterCritical
  });
  return Be({
    impact: a,
    clientSelection: d,
    state: e,
    dimensions: i,
    viewport: o
  });
}, _c = (e) => ({
  index: e.index,
  droppableId: e.droppableId
}), xo = ({
  draggable: e,
  home: t,
  draggables: n,
  viewport: r
}) => {
  const o = Ye(t.axis, e.displaceBy), i = be(t.descriptor.id, n), s = i.indexOf(e);
  s === -1 && (process.env.NODE_ENV !== "production" ? g(!1, "Expected draggable to be inside home list") : g());
  const c = i.slice(s + 1), l = c.reduce((d, f) => (d[f.descriptor.id] = !0, d), {}), u = {
    inVirtualList: t.descriptor.mode === "virtual",
    displacedBy: o,
    effected: l
  };
  return {
    impact: {
      displaced: Ue({
        afterDragging: c,
        destination: t,
        displacedBy: o,
        last: null,
        viewport: r.frame,
        forceShouldAnimate: !1
      }),
      displacedBy: o,
      at: {
        type: "REORDER",
        destination: _c(e.descriptor)
      }
    },
    afterCritical: u
  };
}, Ac = (e, t) => ({
  draggables: e.draggables,
  droppables: fn(e.droppables, t)
});
const Ke = (e) => {
  process.env.NODE_ENV;
}, Xe = (e) => {
  process.env.NODE_ENV;
};
var Pc = ({
  draggable: e,
  offset: t,
  initialWindowScroll: n
}) => {
  const r = ft(e.client, t), o = gt(r, n);
  return C(N({}, e), {
    placeholder: C(N({}, e.placeholder), {
      client: r
    }),
    client: r,
    page: o
  });
}, Rc = (e) => {
  const t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? g(!1, "Expected Droppable to have a frame") : g()), t;
}, Tc = ({
  additions: e,
  updatedDroppables: t,
  viewport: n
}) => {
  const r = n.scroll.diff.value;
  return e.map((o) => {
    const i = o.descriptor.droppableId, s = t[i], l = Rc(s).scroll.diff.value, u = W(r, l);
    return Pc({
      draggable: o,
      offset: u,
      initialWindowScroll: n.scroll.initial
    });
  });
}, Lc = ({
  state: e,
  published: t
}) => {
  Ke();
  const n = t.modified.map((v) => {
    const y = e.dimensions.droppables[v.droppableId];
    return cn(y, v.scroll);
  }), r = N(N({}, e.dimensions.droppables), so(n)), o = co(Tc({
    additions: t.additions,
    updatedDroppables: r,
    viewport: e.viewport
  })), i = N(N({}, e.dimensions.draggables), o);
  t.removals.forEach((v) => {
    delete i[v];
  });
  const s = {
    droppables: r,
    draggables: i
  }, c = Y(e.impact), l = c ? s.droppables[c] : null, u = s.draggables[e.critical.draggable.id], p = s.droppables[e.critical.droppable.id], {
    impact: a,
    afterCritical: d
  } = xo({
    draggable: u,
    home: p,
    draggables: i,
    viewport: e.viewport
  }), f = l && l.isCombineEnabled ? e.impact : a, h = Do({
    pageOffset: e.current.page.offset,
    draggable: s.draggables[e.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: f,
    viewport: e.viewport,
    afterCritical: d
  });
  Xe();
  const b = C(N({}, e), {
    phase: "DRAGGING",
    impact: h,
    onLiftImpact: a,
    dimensions: s,
    afterCritical: d,
    forceShouldAnimate: !1
  });
  return e.phase === "COLLECTING" ? b : C(N({}, b), {
    phase: "DROP_PENDING",
    reason: e.reason,
    isWaiting: !1
  });
};
const Kt = (e) => e.movementMode === "SNAP", Bt = (e, t, n) => {
  const r = Ac(e.dimensions, t);
  return !Kt(e) || n ? Be({
    state: e,
    dimensions: r
  }) : Oo({
    state: e,
    dimensions: r
  });
};
function Vt(e) {
  return e.isDragging && e.movementMode === "SNAP" ? C(N({}, e), {
    scrollJumpRequest: null
  }) : e;
}
const Er = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
};
var Bc = (e = Er, t) => {
  if (t.type === "FLUSH")
    return C(N({}, Er), {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? g(!1, "INITIAL_PUBLISH must come after a IDLE phase") : g());
    const {
      critical: n,
      clientSelection: r,
      viewport: o,
      dimensions: i,
      movementMode: s
    } = t.payload, c = i.draggables[n.draggable.id], l = i.droppables[n.droppable.id], u = {
      selection: r,
      borderBoxCenter: c.client.borderBox.center,
      offset: F
    }, p = {
      client: u,
      page: {
        selection: W(u.selection, o.scroll.initial),
        borderBoxCenter: W(u.selection, o.scroll.initial),
        offset: W(u.selection, o.scroll.diff.value)
      }
    }, a = vt(i.droppables).every((b) => !b.isFixedOnPage), {
      impact: d,
      afterCritical: f
    } = xo({
      draggable: c,
      home: l,
      draggables: i.draggables,
      viewport: o
    });
    return {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: i,
      initial: p,
      current: p,
      isWindowScrollAllowed: a,
      impact: d,
      afterCritical: f,
      onLiftImpact: d,
      viewport: o,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
  }
  if (t.type === "COLLECTION_STARTING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" ? e : (e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? g(!1, `Collection cannot start from phase ${e.phase}`) : g()), C(N({}, e), {
      phase: "COLLECTING"
    }));
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? g(!1, `Unexpected ${t.type} received in phase ${e.phase}`) : g()), Lc({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    ge(e) || (process.env.NODE_ENV !== "production" ? g(!1, `${t.type} not permitted in phase ${e.phase}`) : g());
    const {
      client: n
    } = t.payload;
    return ae(n, e.current.client.selection) ? e : Be({
      state: e,
      clientSelection: n,
      impact: Kt(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return Vt(e);
    ge(e) || (process.env.NODE_ENV !== "production" ? g(!1, `${t.type} not permitted in phase ${e.phase}`) : g());
    const {
      id: n,
      newScroll: r
    } = t.payload, o = e.dimensions.droppables[n];
    if (!o)
      return e;
    const i = cn(o, r);
    return Bt(e, i, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    ge(e) || (process.env.NODE_ENV !== "production" ? g(!1, `Attempting to move in an unsupported phase ${e.phase}`) : g());
    const {
      id: n,
      isEnabled: r
    } = t.payload, o = e.dimensions.droppables[n];
    o || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot find Droppable[id: ${n}] to toggle its enabled state`) : g()), o.isEnabled === r && (process.env.NODE_ENV !== "production" ? g(!1, `Trying to set droppable isEnabled to ${String(r)}
      but it is already ${String(o.isEnabled)}`) : g());
    const i = C(N({}, o), {
      isEnabled: r
    });
    return Bt(e, i, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    ge(e) || (process.env.NODE_ENV !== "production" ? g(!1, `Attempting to move in an unsupported phase ${e.phase}`) : g());
    const {
      id: n,
      isCombineEnabled: r
    } = t.payload, o = e.dimensions.droppables[n];
    o || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot find Droppable[id: ${n}] to toggle its isCombineEnabled state`) : g()), o.isCombineEnabled === r && (process.env.NODE_ENV !== "production" ? g(!1, `Trying to set droppable isCombineEnabled to ${String(r)}
      but it is already ${String(o.isCombineEnabled)}`) : g());
    const i = C(N({}, o), {
      isCombineEnabled: r
    });
    return Bt(e, i, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    ge(e) || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot move by window in phase ${e.phase}`) : g()), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? g(!1, "Window scrolling is currently not supported for fixed lists") : g());
    const n = t.payload.newScroll;
    if (ae(e.viewport.scroll.current, n))
      return Vt(e);
    const r = go(e.viewport, n);
    return Kt(e) ? Oo({
      state: e,
      viewport: r
    }) : Be({
      state: e,
      viewport: r
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!ge(e))
      return e;
    const n = t.payload.maxScroll;
    if (ae(n, e.viewport.scroll.max))
      return e;
    const r = C(N({}, e.viewport), {
      scroll: C(N({}, e.viewport.scroll), {
        max: n
      })
    });
    return C(N({}, e), {
      viewport: r
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? g(!1, `${t.type} received while not in DRAGGING phase`) : g());
    const n = hc({
      state: e,
      type: t.type
    });
    return n ? Be({
      state: e,
      impact: n.impact,
      clientSelection: n.clientSelection,
      scrollJumpRequest: n.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    const n = t.payload.reason;
    return e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? g(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : g()), C(N({}, e), {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: n
    });
  }
  if (t.type === "DROP_ANIMATE") {
    const {
      completed: n,
      dropDuration: r,
      newHomeClientOffset: o
    } = t.payload;
    return e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot animate drop from phase ${e.phase}`) : g()), {
      phase: "DROP_ANIMATING",
      completed: n,
      dropDuration: r,
      newHomeClientOffset: o,
      dimensions: e.dimensions
    };
  }
  if (t.type === "DROP_COMPLETE") {
    const {
      completed: n
    } = t.payload;
    return {
      phase: "IDLE",
      completed: n,
      shouldFlush: !1
    };
  }
  return e;
};
const Vc = (e) => ({
  type: "BEFORE_INITIAL_CAPTURE",
  payload: e
}), Mc = (e) => ({
  type: "LIFT",
  payload: e
}), $c = (e) => ({
  type: "INITIAL_PUBLISH",
  payload: e
}), Gc = (e) => ({
  type: "PUBLISH_WHILE_DRAGGING",
  payload: e
}), Fc = () => ({
  type: "COLLECTION_STARTING",
  payload: null
}), Wc = (e) => ({
  type: "UPDATE_DROPPABLE_SCROLL",
  payload: e
}), Uc = (e) => ({
  type: "UPDATE_DROPPABLE_IS_ENABLED",
  payload: e
}), Hc = (e) => ({
  type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
  payload: e
}), Io = (e) => ({
  type: "MOVE",
  payload: e
}), kc = (e) => ({
  type: "MOVE_BY_WINDOW_SCROLL",
  payload: e
}), jc = (e) => ({
  type: "UPDATE_VIEWPORT_MAX_SCROLL",
  payload: e
}), qc = () => ({
  type: "MOVE_UP",
  payload: null
}), zc = () => ({
  type: "MOVE_DOWN",
  payload: null
}), Yc = () => ({
  type: "MOVE_RIGHT",
  payload: null
}), Kc = () => ({
  type: "MOVE_LEFT",
  payload: null
}), gn = () => ({
  type: "FLUSH",
  payload: null
}), Xc = (e) => ({
  type: "DROP_ANIMATE",
  payload: e
}), mn = (e) => ({
  type: "DROP_COMPLETE",
  payload: e
}), wo = (e) => ({
  type: "DROP",
  payload: e
}), Jc = (e) => ({
  type: "DROP_PENDING",
  payload: e
}), Co = () => ({
  type: "DROP_ANIMATION_FINISHED",
  payload: null
});
function Zc(e) {
  if (e.length <= 1)
    return;
  const t = e.map((o) => o.descriptor.index), n = {};
  for (let o = 1; o < t.length; o++) {
    const i = t[o], s = t[o - 1];
    i !== s + 1 && (n[i] = !0);
  }
  if (!Object.keys(n).length)
    return;
  const r = t.map((o) => !!n[o] ? `[🔥${o}]` : `${o}`).join(", ");
  process.env.NODE_ENV !== "production" && V(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ${r}
  `);
}
function Qc(e, t) {
  if (process.env.NODE_ENV !== "production") {
    const n = be(e.droppable.id, t.draggables);
    Zc(n);
  }
}
var ea = (e) => ({
  getState: t,
  dispatch: n
}) => (r) => (o) => {
  if (o.type !== "LIFT") {
    r(o);
    return;
  }
  const {
    id: i,
    clientSelection: s,
    movementMode: c
  } = o.payload, l = t();
  l.phase === "DROP_ANIMATING" && n(mn({
    completed: l.completed
  })), t().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? g(!1, "Unexpected phase to start a drag") : g()), n(gn()), n(Vc({
    draggableId: i,
    movementMode: c
  }));
  const p = {
    draggableId: i,
    scrollOptions: {
      shouldPublishImmediately: c === "SNAP"
    }
  }, {
    critical: a,
    dimensions: d,
    viewport: f
  } = e.startPublishing(p);
  Qc(a, d), n($c({
    critical: a,
    dimensions: d,
    clientSelection: s,
    movementMode: c,
    viewport: f
  }));
}, ta = (e) => () => (t) => (n) => {
  n.type === "INITIAL_PUBLISH" && e.dragging(), n.type === "DROP_ANIMATE" && e.dropping(n.payload.completed.result.reason), (n.type === "FLUSH" || n.type === "DROP_COMPLETE") && e.resting(), t(n);
};
const bn = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, He = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, _o = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, pe = `${_o.outOfTheWay}s ${bn.outOfTheWay}`, Ve = {
  fluid: `opacity ${pe}`,
  snap: `transform ${pe}, opacity ${pe}`,
  drop: (e) => {
    const t = `${e}s ${bn.drop}`;
    return `transform ${t}, opacity ${t}`;
  },
  outOfTheWay: `transform ${pe}`,
  placeholder: `height ${pe}, width ${pe}, margin ${pe}`
}, Dr = (e) => ae(e, F) ? void 0 : `translate(${e.x}px, ${e.y}px)`, Xt = {
  moveTo: Dr,
  drop: (e, t) => {
    const n = Dr(e);
    if (n)
      return t ? `${n} scale(${He.scale.drop})` : n;
  }
}, {
  minDropTime: Jt,
  maxDropTime: Ao
} = _o, na = Ao - Jt, Nr = 1500, ra = 0.6;
var oa = ({
  current: e,
  destination: t,
  reason: n
}) => {
  const r = Fe(e, t);
  if (r <= 0)
    return Jt;
  if (r >= Nr)
    return Ao;
  const o = r / Nr, i = Jt + na * o, s = n === "CANCEL" ? i * ra : i;
  return Number(s.toFixed(2));
}, ia = ({
  impact: e,
  draggable: t,
  dimensions: n,
  viewport: r,
  afterCritical: o
}) => {
  const {
    draggables: i,
    droppables: s
  } = n, c = Y(e), l = c ? s[c] : null, u = s[t.descriptor.droppableId], p = So({
    impact: e,
    draggable: t,
    draggables: i,
    afterCritical: o,
    droppable: l || u,
    viewport: r
  });
  return z(p, t.client.borderBox.center);
}, sa = ({
  draggables: e,
  reason: t,
  lastImpact: n,
  home: r,
  viewport: o,
  onLiftImpact: i
}) => !n.at || t !== "DROP" ? {
  impact: No({
    draggables: e,
    impact: i,
    destination: r,
    viewport: o,
    forceShouldAnimate: !0
  }),
  didDropInsideDroppable: !1
} : n.at.type === "REORDER" ? {
  impact: n,
  didDropInsideDroppable: !0
} : {
  impact: C(N({}, n), {
    displaced: We
  }),
  didDropInsideDroppable: !0
};
const ca = ({
  getState: e,
  dispatch: t
}) => (n) => (r) => {
  if (r.type !== "DROP") {
    n(r);
    return;
  }
  const o = e(), i = r.payload.reason;
  if (o.phase === "COLLECTING") {
    t(Jc({
      reason: i
    }));
    return;
  }
  if (o.phase === "IDLE")
    return;
  o.phase === "DROP_PENDING" && o.isWaiting && (process.env.NODE_ENV !== "production" ? g(!1, "A DROP action occurred while DROP_PENDING and still waiting") : g()), o.phase === "DRAGGING" || o.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot drop in phase: ${o.phase}`) : g());
  const c = o.critical, l = o.dimensions, u = l.draggables[o.critical.draggable.id], {
    impact: p,
    didDropInsideDroppable: a
  } = sa({
    reason: i,
    lastImpact: o.impact,
    afterCritical: o.afterCritical,
    onLiftImpact: o.onLiftImpact,
    home: o.dimensions.droppables[o.critical.droppable.id],
    viewport: o.viewport,
    draggables: o.dimensions.draggables
  }), d = a ? an(p) : null, f = a ? yt(p) : null, h = {
    index: c.draggable.index,
    droppableId: c.droppable.id
  }, b = {
    draggableId: u.descriptor.id,
    type: u.descriptor.type,
    source: h,
    reason: i,
    mode: o.movementMode,
    destination: d,
    combine: f
  }, m = ia({
    impact: p,
    draggable: u,
    dimensions: l,
    viewport: o.viewport,
    afterCritical: o.afterCritical
  }), v = {
    critical: o.critical,
    afterCritical: o.afterCritical,
    result: b,
    impact: p
  };
  if (!(!ae(o.current.client.offset, m) || !!b.combine)) {
    t(mn({
      completed: v
    }));
    return;
  }
  const O = oa({
    current: o.current.client.offset,
    destination: m,
    reason: i
  });
  t(Xc({
    newHomeClientOffset: m,
    dropDuration: O,
    completed: v
  }));
};
var aa = ca, Po = () => ({
  x: window.pageXOffset,
  y: window.pageYOffset
});
function la(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: (t) => {
      t.target !== window && t.target !== window.document || e();
    }
  };
}
function ua({
  onWindowScroll: e
}) {
  function t() {
    e(Po());
  }
  const n = $e(t), r = la(n);
  let o = ce;
  function i() {
    return o !== ce;
  }
  function s() {
    i() && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot start scroll listener when already active") : g()), o = ee(window, [r]);
  }
  function c() {
    i() || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot stop scroll listener when not active") : g()), n.cancel(), o(), o = ce;
  }
  return {
    start: s,
    stop: c,
    isActive: i
  };
}
const da = (e) => e.type === "DROP_COMPLETE" || e.type === "DROP_ANIMATE" || e.type === "FLUSH", pa = (e) => {
  const t = ua({
    onWindowScroll: (n) => {
      e.dispatch(kc({
        newScroll: n
      }));
    }
  });
  return (n) => (r) => {
    !t.isActive() && r.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && da(r) && t.stop(), n(r);
  };
};
var fa = pa, ga = (e) => {
  let t = !1, n = !1;
  const r = setTimeout(() => {
    n = !0;
  }), o = (i) => {
    if (t) {
      process.env.NODE_ENV !== "production" && V("Announcement already made. Not making a second announcement");
      return;
    }
    if (n) {
      process.env.NODE_ENV !== "production" && V(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(i), clearTimeout(r);
  };
  return o.wasCalled = () => t, o;
}, ma = () => {
  const e = [], t = (o) => {
    const i = e.findIndex((c) => c.timerId === o);
    i === -1 && (process.env.NODE_ENV !== "production" ? g(!1, "Could not find timer") : g());
    const [s] = e.splice(i, 1);
    s.callback();
  };
  return {
    add: (o) => {
      const i = setTimeout(() => t(i)), s = {
        timerId: i,
        callback: o
      };
      e.push(s);
    },
    flush: () => {
      if (!e.length)
        return;
      const o = [...e];
      e.length = 0, o.forEach((i) => {
        clearTimeout(i.timerId), i.callback();
      });
    }
  };
};
const ba = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.droppableId === t.droppableId && e.index === t.index, ha = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.draggableId === t.draggableId && e.droppableId === t.droppableId, va = (e, t) => {
  if (e === t)
    return !0;
  const n = e.draggable.id === t.draggable.id && e.draggable.droppableId === t.draggable.droppableId && e.draggable.type === t.draggable.type && e.draggable.index === t.draggable.index, r = e.droppable.id === t.droppable.id && e.droppable.type === t.droppable.type;
  return n && r;
}, Re = (e, t) => {
  Ke(), t(), Xe();
}, ct = (e, t) => ({
  draggableId: e.draggable.id,
  type: e.droppable.type,
  source: {
    droppableId: e.droppable.id,
    index: e.draggable.index
  },
  mode: t
});
function Mt(e, t, n, r) {
  if (!e) {
    n(r(t));
    return;
  }
  const o = ga(n);
  e(t, {
    announce: o
  }), o.wasCalled() || n(r(t));
}
var ya = (e, t) => {
  const n = ma();
  let r = null;
  const o = (a, d) => {
    r && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : g()), Re("onBeforeCapture", () => {
      const f = e().onBeforeCapture;
      f && f({
        draggableId: a,
        mode: d
      });
    });
  }, i = (a, d) => {
    r && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : g()), Re("onBeforeDragStart", () => {
      const f = e().onBeforeDragStart;
      f && f(ct(a, d));
    });
  }, s = (a, d) => {
    r && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : g());
    const f = ct(a, d);
    r = {
      mode: d,
      lastCritical: a,
      lastLocation: f.source,
      lastCombine: null
    }, n.add(() => {
      Re("onDragStart", () => Mt(e().onDragStart, f, t, dt.onDragStart));
    });
  }, c = (a, d) => {
    const f = an(d), h = yt(d);
    r || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fire onDragMove when onDragStart has not been called") : g());
    const b = !va(a, r.lastCritical);
    b && (r.lastCritical = a);
    const m = !ba(r.lastLocation, f);
    m && (r.lastLocation = f);
    const v = !ha(r.lastCombine, h);
    if (v && (r.lastCombine = h), !b && !m && !v)
      return;
    const y = C(N({}, ct(a, r.mode)), {
      combine: h,
      destination: f
    });
    n.add(() => {
      Re("onDragUpdate", () => Mt(e().onDragUpdate, y, t, dt.onDragUpdate));
    });
  }, l = () => {
    r || (process.env.NODE_ENV !== "production" ? g(!1, "Can only flush responders while dragging") : g()), n.flush();
  }, u = (a) => {
    r || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : g()), r = null, Re("onDragEnd", () => Mt(e().onDragEnd, a, t, dt.onDragEnd));
  };
  return {
    beforeCapture: o,
    beforeStart: i,
    start: s,
    update: c,
    flush: l,
    drop: u,
    abort: () => {
      if (!r)
        return;
      const a = C(N({}, ct(r.lastCritical, r.mode)), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      u(a);
    }
  };
}, Ea = (e, t) => {
  const n = ya(e, t);
  return (r) => (o) => (i) => {
    if (i.type === "BEFORE_INITIAL_CAPTURE") {
      n.beforeCapture(i.payload.draggableId, i.payload.movementMode);
      return;
    }
    if (i.type === "INITIAL_PUBLISH") {
      const c = i.payload.critical;
      n.beforeStart(c, i.payload.movementMode), o(i), n.start(c, i.payload.movementMode);
      return;
    }
    if (i.type === "DROP_COMPLETE") {
      const c = i.payload.completed.result;
      n.flush(), o(i), n.drop(c);
      return;
    }
    if (o(i), i.type === "FLUSH") {
      n.abort();
      return;
    }
    const s = r.getState();
    s.phase === "DRAGGING" && n.update(s.critical, s.impact);
  };
};
const Da = (e) => (t) => (n) => {
  if (n.type !== "DROP_ANIMATION_FINISHED") {
    t(n);
    return;
  }
  const r = e.getState();
  r.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot finish a drop animating when no drop is occurring") : g()), e.dispatch(mn({
    completed: r.completed
  }));
};
var Na = Da;
const Sa = (e) => {
  let t = null, n = null;
  function r() {
    n && (cancelAnimationFrame(n), n = null), t && (t(), t = null);
  }
  return (o) => (i) => {
    if ((i.type === "FLUSH" || i.type === "DROP_COMPLETE" || i.type === "DROP_ANIMATION_FINISHED") && r(), o(i), i.type !== "DROP_ANIMATE")
      return;
    const s = {
      eventName: "scroll",
      options: {
        capture: !0,
        passive: !1,
        once: !0
      },
      fn: function() {
        e.getState().phase === "DROP_ANIMATING" && e.dispatch(Co());
      }
    };
    n = requestAnimationFrame(() => {
      n = null, t = ee(window, [s]);
    });
  };
};
var Oa = Sa, xa = (e) => () => (t) => (n) => {
  (n.type === "DROP_COMPLETE" || n.type === "FLUSH" || n.type === "DROP_ANIMATE") && e.stopPublishing(), t(n);
}, Ia = (e) => {
  let t = !1;
  return () => (n) => (r) => {
    if (r.type === "INITIAL_PUBLISH") {
      t = !0, e.tryRecordFocus(r.payload.critical.draggable.id), n(r), e.tryRestoreFocusRecorded();
      return;
    }
    if (n(r), !!t) {
      if (r.type === "FLUSH") {
        t = !1, e.tryRestoreFocusRecorded();
        return;
      }
      if (r.type === "DROP_COMPLETE") {
        t = !1;
        const o = r.payload.completed.result;
        o.combine && e.tryShiftRecord(o.draggableId, o.combine.draggableId), e.tryRestoreFocusRecorded();
      }
    }
  };
};
const wa = (e) => e.type === "DROP_COMPLETE" || e.type === "DROP_ANIMATE" || e.type === "FLUSH";
var Ca = (e) => (t) => (n) => (r) => {
  if (wa(r)) {
    e.stop(), n(r);
    return;
  }
  if (r.type === "INITIAL_PUBLISH") {
    n(r);
    const o = t.getState();
    o.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? g(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : g()), e.start(o);
    return;
  }
  n(r), e.scroll(t.getState());
};
const _a = (e) => (t) => (n) => {
  if (t(n), n.type !== "PUBLISH_WHILE_DRAGGING")
    return;
  const r = e.getState();
  r.phase === "DROP_PENDING" && (r.isWaiting || e.dispatch(wo({
    reason: r.reason
  })));
};
var Aa = _a;
const Pa = process.env.NODE_ENV !== "production" && typeof window != "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "@hello-pangea/dnd"
}) : kr;
var Ra = ({
  dimensionMarshal: e,
  focusMarshal: t,
  styleMarshal: n,
  getResponders: r,
  announce: o,
  autoScroller: i
}) => Hr(Bc, Pa(xi(ta(n), xa(e), ea(e), aa, Na, Oa, Aa, Ca(i), fa, Ia(t), Ea(r, o))));
const $t = () => ({
  additions: {},
  removals: {},
  modified: {}
});
function Ta({
  registry: e,
  callbacks: t
}) {
  let n = $t(), r = null;
  const o = () => {
    r || (t.collectionStarting(), r = requestAnimationFrame(() => {
      r = null, Ke();
      const {
        additions: l,
        removals: u,
        modified: p
      } = n, a = Object.keys(l).map((h) => e.draggable.getById(h).getDimension(F)).sort((h, b) => h.descriptor.index - b.descriptor.index), d = Object.keys(p).map((h) => {
        const m = e.droppable.getById(h).callbacks.getScrollWhileDragging();
        return {
          droppableId: h,
          scroll: m
        };
      }), f = {
        additions: a,
        removals: Object.keys(u),
        modified: d
      };
      n = $t(), Xe(), t.publish(f);
    }));
  };
  return {
    add: (l) => {
      const u = l.descriptor.id;
      n.additions[u] = l, n.modified[l.descriptor.droppableId] = !0, n.removals[u] && delete n.removals[u], o();
    },
    remove: (l) => {
      const u = l.descriptor;
      n.removals[u.id] = !0, n.modified[u.droppableId] = !0, n.additions[u.id] && delete n.additions[u.id], o();
    },
    stop: () => {
      r && (cancelAnimationFrame(r), r = null, n = $t());
    }
  };
}
var Ro = ({
  scrollHeight: e,
  scrollWidth: t,
  height: n,
  width: r
}) => {
  const o = z({
    x: t,
    y: e
  }, {
    x: r,
    y: n
  });
  return {
    x: Math.max(0, o.x),
    y: Math.max(0, o.y)
  };
}, To = () => {
  const e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot find document.documentElement") : g()), e;
}, Lo = () => {
  const e = To();
  return Ro({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
}, La = () => {
  const e = Po(), t = Lo(), n = e.y, r = e.x, o = To(), i = o.clientWidth, s = o.clientHeight, c = r + i, l = n + s;
  return {
    frame: ne({
      top: n,
      left: r,
      right: c,
      bottom: l
    }),
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: F,
        displacement: F
      }
    }
  };
}, Ba = ({
  critical: e,
  scrollOptions: t,
  registry: n
}) => {
  Ke();
  const r = La(), o = r.scroll.current, i = e.droppable, s = n.droppable.getAllByType(i.type).map((p) => p.callbacks.getDimensionAndWatchScroll(o, t)), c = n.draggable.getAllByType(e.draggable.type).map((p) => p.getDimension(o)), l = {
    draggables: co(c),
    droppables: so(s)
  };
  return Xe(), {
    dimensions: l,
    critical: e,
    viewport: r
  };
};
function Sr(e, t, n) {
  return n.descriptor.id === t.id || n.descriptor.type !== t.type ? !1 : e.droppable.getById(n.descriptor.droppableId).descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && V(`
      You are attempting to add or remove a Draggable [id: ${n.descriptor.id}]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/hello-pangea/dnd/blob/main/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var Va = (e, t) => {
  let n = null;
  const r = Ta({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), o = (d, f) => {
    e.droppable.exists(d) || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot update is enabled flag of Droppable ${d} as it is not registered`) : g()), n && t.updateDroppableIsEnabled({
      id: d,
      isEnabled: f
    });
  }, i = (d, f) => {
    n && (e.droppable.exists(d) || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot update isCombineEnabled flag of Droppable ${d} as it is not registered`) : g()), t.updateDroppableIsCombineEnabled({
      id: d,
      isCombineEnabled: f
    }));
  }, s = (d, f) => {
    n && (e.droppable.exists(d) || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot update the scroll on Droppable ${d} as it is not registered`) : g()), t.updateDroppableScroll({
      id: d,
      newScroll: f
    }));
  }, c = (d, f) => {
    n && e.droppable.getById(d).callbacks.scroll(f);
  }, l = () => {
    if (!n)
      return;
    r.stop();
    const d = n.critical.droppable;
    e.droppable.getAllByType(d.type).forEach((f) => f.callbacks.dragStopped()), n.unsubscribe(), n = null;
  }, u = (d) => {
    n || (process.env.NODE_ENV !== "production" ? g(!1, "Should only be subscribed when a collection is occurring") : g());
    const f = n.critical.draggable;
    d.type === "ADDITION" && Sr(e, f, d.value) && r.add(d.value), d.type === "REMOVAL" && Sr(e, f, d.value) && r.remove(d.value);
  };
  return {
    updateDroppableIsEnabled: o,
    updateDroppableIsCombineEnabled: i,
    scrollDroppable: c,
    updateDroppableScroll: s,
    startPublishing: (d) => {
      n && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot start capturing critical dimensions as there is already a collection") : g());
      const f = e.draggable.getById(d.draggableId), h = e.droppable.getById(f.descriptor.droppableId), b = {
        draggable: f.descriptor,
        droppable: h.descriptor
      }, m = e.subscribe(u);
      return n = {
        critical: b,
        unsubscribe: m
      }, Ba({
        critical: b,
        registry: e,
        scrollOptions: d.scrollOptions
      });
    },
    stopPublishing: l
  };
}, Bo = (e, t) => e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP", Ma = (e) => {
  window.scrollBy(e.x, e.y);
};
const $a = G((e) => vt(e).filter((t) => !(!t.isEnabled || !t.frame))), Ga = (e, t) => $a(t).find((r) => (r.frame || (process.env.NODE_ENV !== "production" ? g(!1, "Invalid result") : g()), vo(r.frame.pageMarginBox)(e))) || null;
var Fa = ({
  center: e,
  destination: t,
  droppables: n
}) => {
  if (t) {
    const o = n[t];
    return o.frame ? o : null;
  }
  return Ga(e, n);
};
const ke = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: (e) => rt(e, 2),
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  },
  disabled: !1
};
var Wa = (e, t, n = () => ke) => {
  const r = n(), o = e[t.size] * r.startFromPercentage, i = e[t.size] * r.maxScrollAtPercentage;
  return {
    startScrollingFrom: o,
    maxScrollValueAt: i
  };
}, Vo = ({
  startOfRange: e,
  endOfRange: t,
  current: n
}) => {
  const r = t - e;
  return r === 0 ? (process.env.NODE_ENV !== "production" && V(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0) : (n - e) / r;
}, hn = 1, Ua = (e, t, n = () => ke) => {
  const r = n();
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return r.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return hn;
  const i = 1 - Vo({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), s = r.maxPixelScroll * r.ease(i);
  return Math.ceil(s);
}, Ha = (e, t, n) => {
  const r = n(), o = r.durationDampening.accelerateAt, i = r.durationDampening.stopDampeningAt, s = t, c = i, u = Date.now() - s;
  if (u >= i)
    return e;
  if (u < o)
    return hn;
  const p = Vo({
    startOfRange: o,
    endOfRange: c,
    current: u
  }), a = e * r.ease(p);
  return Math.ceil(a);
}, Or = ({
  distanceToEdge: e,
  thresholds: t,
  dragStartTime: n,
  shouldUseTimeDampening: r,
  getAutoScrollerOptions: o
}) => {
  const i = Ua(e, t, o);
  return i === 0 ? 0 : r ? Math.max(Ha(i, n, o), hn) : i;
}, xr = ({
  container: e,
  distanceToEdges: t,
  dragStartTime: n,
  axis: r,
  shouldUseTimeDampening: o,
  getAutoScrollerOptions: i
}) => {
  const s = Wa(e, r, i);
  return t[r.end] < t[r.start] ? Or({
    distanceToEdge: t[r.end],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  }) : -1 * Or({
    distanceToEdge: t[r.start],
    thresholds: s,
    dragStartTime: n,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  });
}, ka = ({
  container: e,
  subject: t,
  proposedScroll: n
}) => {
  const r = t.height > e.height, o = t.width > e.width;
  return !o && !r ? n : o && r ? null : {
    x: o ? 0 : n.x,
    y: r ? 0 : n.y
  };
};
const ja = io((e) => e === 0 ? 0 : e);
var Mo = ({
  dragStartTime: e,
  container: t,
  subject: n,
  center: r,
  shouldUseTimeDampening: o,
  getAutoScrollerOptions: i
}) => {
  const s = {
    top: r.y - t.top,
    right: t.right - r.x,
    bottom: t.bottom - r.y,
    left: r.x - t.left
  }, c = xr({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: ln,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  }), l = xr({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: uo,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  }), u = ja({
    x: l,
    y: c
  });
  if (ae(u, F))
    return null;
  const p = ka({
    container: t,
    subject: n,
    proposedScroll: u
  });
  return p ? ae(p, F) ? null : p : null;
};
const qa = io((e) => e === 0 ? 0 : e > 0 ? 1 : -1), vn = /* @__PURE__ */ (() => {
  const e = (t, n) => t < 0 ? t : t > n ? t - n : 0;
  return ({
    current: t,
    max: n,
    change: r
  }) => {
    const o = W(t, r), i = {
      x: e(o.x, n.x),
      y: e(o.y, n.y)
    };
    return ae(i, F) ? null : i;
  };
})(), $o = ({
  max: e,
  current: t,
  change: n
}) => {
  const r = {
    x: Math.max(t.x, e.x),
    y: Math.max(t.y, e.y)
  }, o = qa(n), i = vn({
    max: r,
    current: t,
    change: o
  });
  return !i || o.x !== 0 && i.x === 0 || o.y !== 0 && i.y === 0;
}, yn = (e, t) => $o({
  current: e.scroll.current,
  max: e.scroll.max,
  change: t
}), za = (e, t) => {
  if (!yn(e, t))
    return null;
  const n = e.scroll.max, r = e.scroll.current;
  return vn({
    current: r,
    max: n,
    change: t
  });
}, En = (e, t) => {
  const n = e.frame;
  return n ? $o({
    current: n.scroll.current,
    max: n.scroll.max,
    change: t
  }) : !1;
}, Ya = (e, t) => {
  const n = e.frame;
  return !n || !En(e, t) ? null : vn({
    current: n.scroll.current,
    max: n.scroll.max,
    change: t
  });
};
var Ka = ({
  viewport: e,
  subject: t,
  center: n,
  dragStartTime: r,
  shouldUseTimeDampening: o,
  getAutoScrollerOptions: i
}) => {
  const s = Mo({
    dragStartTime: r,
    container: e.frame,
    subject: t,
    center: n,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  });
  return s && yn(e, s) ? s : null;
}, Xa = ({
  droppable: e,
  subject: t,
  center: n,
  dragStartTime: r,
  shouldUseTimeDampening: o,
  getAutoScrollerOptions: i
}) => {
  const s = e.frame;
  if (!s)
    return null;
  const c = Mo({
    dragStartTime: r,
    container: s.pageMarginBox,
    subject: t,
    center: n,
    shouldUseTimeDampening: o,
    getAutoScrollerOptions: i
  });
  return c && En(e, c) ? c : null;
}, Ir = ({
  state: e,
  dragStartTime: t,
  shouldUseTimeDampening: n,
  scrollWindow: r,
  scrollDroppable: o,
  getAutoScrollerOptions: i
}) => {
  const s = e.current.page.borderBoxCenter, l = e.dimensions.draggables[e.critical.draggable.id].page.marginBox;
  if (e.isWindowScrollAllowed) {
    const a = e.viewport, d = Ka({
      dragStartTime: t,
      viewport: a,
      subject: l,
      center: s,
      shouldUseTimeDampening: n,
      getAutoScrollerOptions: i
    });
    if (d) {
      r(d);
      return;
    }
  }
  const u = Fa({
    center: s,
    destination: Y(e.impact),
    droppables: e.dimensions.droppables
  });
  if (!u)
    return;
  const p = Xa({
    dragStartTime: t,
    droppable: u,
    subject: l,
    center: s,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: i
  });
  p && o(u.descriptor.id, p);
}, Ja = ({
  scrollWindow: e,
  scrollDroppable: t,
  getAutoScrollerOptions: n = () => ke
}) => {
  const r = $e(e), o = $e(t);
  let i = null;
  const s = (u) => {
    i || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot fluid scroll if not dragging") : g());
    const {
      shouldUseTimeDampening: p,
      dragStartTime: a
    } = i;
    Ir({
      state: u,
      scrollWindow: r,
      scrollDroppable: o,
      dragStartTime: a,
      shouldUseTimeDampening: p,
      getAutoScrollerOptions: n
    });
  };
  return {
    start: (u) => {
      Ke(), i && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot start auto scrolling when already started") : g());
      const p = Date.now();
      let a = !1;
      const d = () => {
        a = !0;
      };
      Ir({
        state: u,
        dragStartTime: 0,
        shouldUseTimeDampening: !1,
        scrollWindow: d,
        scrollDroppable: d,
        getAutoScrollerOptions: n
      }), i = {
        dragStartTime: p,
        shouldUseTimeDampening: a
      }, Xe(), a && s(u);
    },
    stop: () => {
      i && (r.cancel(), o.cancel(), i = null);
    },
    scroll: s
  };
}, Za = ({
  move: e,
  scrollDroppable: t,
  scrollWindow: n
}) => {
  const r = (c, l) => {
    const u = W(c.current.client.selection, l);
    e({
      client: u
    });
  }, o = (c, l) => {
    if (!En(c, l))
      return l;
    const u = Ya(c, l);
    if (!u)
      return t(c.descriptor.id, l), null;
    const p = z(l, u);
    return t(c.descriptor.id, p), z(l, p);
  }, i = (c, l, u) => {
    if (!c || !yn(l, u))
      return u;
    const p = za(l, u);
    if (!p)
      return n(u), null;
    const a = z(u, p);
    return n(a), z(u, a);
  };
  return (c) => {
    const l = c.scrollJumpRequest;
    if (!l)
      return;
    const u = Y(c.impact);
    u || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot perform a jump scroll when there is no destination") : g());
    const p = o(c.dimensions.droppables[u], l);
    if (!p)
      return;
    const a = c.viewport, d = i(c.isWindowScrollAllowed, a, p);
    d && r(c, d);
  };
}, Qa = ({
  scrollDroppable: e,
  scrollWindow: t,
  move: n,
  getAutoScrollerOptions: r
}) => {
  const o = Ja({
    scrollWindow: t,
    scrollDroppable: e,
    getAutoScrollerOptions: r
  }), i = Za({
    move: n,
    scrollWindow: t,
    scrollDroppable: e
  });
  return {
    scroll: (l) => {
      if (!(r().disabled || l.phase !== "DRAGGING")) {
        if (l.movementMode === "FLUID") {
          o.scroll(l);
          return;
        }
        l.scrollJumpRequest && i(l);
      }
    },
    start: o.start,
    stop: o.stop
  };
};
const Ee = "data-rfd", De = (() => {
  const e = `${Ee}-drag-handle`;
  return {
    base: e,
    draggableId: `${e}-draggable-id`,
    contextId: `${e}-context-id`
  };
})(), Zt = (() => {
  const e = `${Ee}-draggable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), el = (() => {
  const e = `${Ee}-droppable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), wr = {
  contextId: `${Ee}-scroll-container-context-id`
}, tl = (e) => (t) => `[${t}="${e}"]`, Te = (e, t) => e.map((n) => {
  const r = n.styles[t];
  return r ? `${n.selector} { ${r} }` : "";
}).join(" "), nl = "pointer-events: none;";
var rl = (e) => {
  const t = tl(e), n = (() => {
    const c = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(De.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: c,
        dragging: nl,
        dropAnimating: c
      }
    };
  })(), r = (() => {
    const c = `
      transition: ${Ve.outOfTheWay};
    `;
    return {
      selector: t(Zt.contextId),
      styles: {
        dragging: c,
        dropAnimating: c,
        userCancel: c
      }
    };
  })(), o = {
    selector: t(el.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, s = [r, n, o, {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }];
  return {
    always: Te(s, "always"),
    resting: Te(s, "resting"),
    dragging: Te(s, "dragging"),
    dropAnimating: Te(s, "dropAnimating"),
    userCancel: Te(s, "userCancel")
  };
};
const ol = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? ai : re;
var K = ol;
const Gt = () => {
  const e = document.querySelector("head");
  return e || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot find the head to append a style to") : g()), e;
}, Cr = (e) => {
  const t = document.createElement("style");
  return e && t.setAttribute("nonce", e), t.type = "text/css", t;
};
function il(e, t) {
  const n = A(() => rl(e), [e]), r = M(null), o = M(null), i = x(G((a) => {
    const d = o.current;
    d || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot set dynamic style element if it is not set") : g()), d.textContent = a;
  }), []), s = x((a) => {
    const d = r.current;
    d || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot set dynamic style element if it is not set") : g()), d.textContent = a;
  }, []);
  K(() => {
    !r.current && !o.current || (process.env.NODE_ENV !== "production" ? g(!1, "style elements already mounted") : g());
    const a = Cr(t), d = Cr(t);
    return r.current = a, o.current = d, a.setAttribute(`${Ee}-always`, e), d.setAttribute(`${Ee}-dynamic`, e), Gt().appendChild(a), Gt().appendChild(d), s(n.always), i(n.resting), () => {
      const f = (h) => {
        const b = h.current;
        b || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot unmount ref as it is not set") : g()), Gt().removeChild(b), h.current = null;
      };
      f(r), f(o);
    };
  }, [t, s, i, n.always, n.resting, e]);
  const c = x(() => i(n.dragging), [i, n.dragging]), l = x((a) => {
    if (a === "DROP") {
      i(n.dropAnimating);
      return;
    }
    i(n.userCancel);
  }, [i, n.dropAnimating, n.userCancel]), u = x(() => {
    o.current && i(n.resting);
  }, [i, n.resting]);
  return A(() => ({
    dragging: c,
    dropping: l,
    resting: u
  }), [c, l, u]);
}
function Go(e, t) {
  return Array.from(e.querySelectorAll(t));
}
var Fo = (e) => e && e.ownerDocument && e.ownerDocument.defaultView ? e.ownerDocument.defaultView : window;
function Je(e) {
  return e instanceof Fo(e).HTMLElement;
}
function Wo(e, t) {
  const n = `[${De.contextId}="${e}"]`, r = Go(document, n);
  if (!r.length)
    return process.env.NODE_ENV !== "production" && V(`Unable to find any drag handles in the context "${e}"`), null;
  const o = r.find((i) => i.getAttribute(De.draggableId) === t);
  return o ? Je(o) ? o : (process.env.NODE_ENV !== "production" && V("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && V(`Unable to find drag handle with id "${t}" as no handle with a matching id was found`), null);
}
function sl(e) {
  const t = M({}), n = M(null), r = M(null), o = M(!1), i = x(function(d, f) {
    const h = {
      id: d,
      focus: f
    };
    return t.current[d] = h, function() {
      const m = t.current;
      m[d] !== h && delete m[d];
    };
  }, []), s = x(function(d) {
    const f = Wo(e, d);
    f && f !== document.activeElement && f.focus();
  }, [e]), c = x(function(d, f) {
    n.current === d && (n.current = f);
  }, []), l = x(function() {
    r.current || o.current && (r.current = requestAnimationFrame(() => {
      r.current = null;
      const d = n.current;
      d && s(d);
    }));
  }, [s]), u = x(function(d) {
    n.current = null;
    const f = document.activeElement;
    f && f.getAttribute(De.draggableId) === d && (n.current = d);
  }, []);
  return K(() => (o.current = !0, function() {
    o.current = !1;
    const d = r.current;
    d && cancelAnimationFrame(d);
  }), []), A(() => ({
    register: i,
    tryRecordFocus: u,
    tryRestoreFocusRecorded: l,
    tryShiftRecord: c
  }), [i, u, l, c]);
}
function cl() {
  const e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function n(a) {
    return t.push(a), function() {
      const f = t.indexOf(a);
      f !== -1 && t.splice(f, 1);
    };
  }
  function r(a) {
    t.length && t.forEach((d) => d(a));
  }
  function o(a) {
    return e.draggables[a] || null;
  }
  function i(a) {
    const d = o(a);
    return d || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot find draggable entry with id [${a}]`) : g()), d;
  }
  const s = {
    register: (a) => {
      e.draggables[a.descriptor.id] = a, r({
        type: "ADDITION",
        value: a
      });
    },
    update: (a, d) => {
      const f = e.draggables[d.descriptor.id];
      f && f.uniqueId === a.uniqueId && (delete e.draggables[d.descriptor.id], e.draggables[a.descriptor.id] = a);
    },
    unregister: (a) => {
      const d = a.descriptor.id, f = o(d);
      f && a.uniqueId === f.uniqueId && (delete e.draggables[d], e.droppables[a.descriptor.droppableId] && r({
        type: "REMOVAL",
        value: a
      }));
    },
    getById: i,
    findById: o,
    exists: (a) => !!o(a),
    getAllByType: (a) => Object.values(e.draggables).filter((d) => d.descriptor.type === a)
  };
  function c(a) {
    return e.droppables[a] || null;
  }
  function l(a) {
    const d = c(a);
    return d || (process.env.NODE_ENV !== "production" ? g(!1, `Cannot find droppable entry with id [${a}]`) : g()), d;
  }
  const u = {
    register: (a) => {
      e.droppables[a.descriptor.id] = a;
    },
    unregister: (a) => {
      const d = c(a.descriptor.id);
      d && a.uniqueId === d.uniqueId && delete e.droppables[a.descriptor.id];
    },
    getById: l,
    findById: c,
    exists: (a) => !!c(a),
    getAllByType: (a) => Object.values(e.droppables).filter((d) => d.descriptor.type === a)
  };
  function p() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: s,
    droppable: u,
    subscribe: n,
    clean: p
  };
}
function al() {
  const e = A(cl, []);
  return re(() => function() {
    P.version.startsWith("16") || P.version.startsWith("17") ? requestAnimationFrame(e.clean) : e.clean();
  }, [e]), e;
}
var Dn = P.createContext(null), je = () => {
  const e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot find document.body") : g()), e;
};
const ll = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
};
var ul = ll;
const dl = (e) => `rfd-announcement-${e}`;
function pl(e) {
  const t = A(() => dl(e), [e]), n = M(null);
  return re(function() {
    const i = document.createElement("div");
    return n.current = i, i.id = t, i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true"), se(i.style, ul), je().appendChild(i), function() {
      setTimeout(function() {
        const l = je();
        l.contains(i) && l.removeChild(i), i === n.current && (n.current = null);
      });
    };
  }, [t]), x((o) => {
    const i = n.current;
    if (i) {
      i.textContent = o;
      return;
    }
    process.env.NODE_ENV !== "production" && V(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "${o}"
    `);
  }, []);
}
let fl = 0;
const Uo = {
  separator: "::"
};
function gl(e, t = Uo) {
  return A(() => `${e}${t.separator}${fl++}`, [t.separator, e]);
}
function ml(e, t = Uo) {
  const n = P.useId();
  return A(() => `${e}${t.separator}${n}`, [t.separator, e, n]);
}
var Nn = "useId" in P ? ml : gl;
function bl({
  contextId: e,
  uniqueId: t
}) {
  return `rfd-hidden-text-${e}-${t}`;
}
function hl({
  contextId: e,
  text: t
}) {
  const n = Nn("hidden-text", {
    separator: "-"
  }), r = A(() => bl({
    contextId: e,
    uniqueId: n
  }), [n, e]);
  return re(function() {
    const i = document.createElement("div");
    return i.id = r, i.textContent = t, i.style.display = "none", je().appendChild(i), function() {
      const c = je();
      c.contains(i) && c.removeChild(i);
    };
  }, [r, t]), r;
}
var Nt = P.createContext(null), vl = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
const yl = /(\d+)\.(\d+)\.(\d+)/, _r = (e) => {
  const t = yl.exec(e);
  t == null && (process.env.NODE_ENV !== "production" ? g(!1, `Unable to parse React version ${e}`) : g());
  const n = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return {
    major: n,
    minor: r,
    patch: o,
    raw: e
  };
}, El = (e, t) => t.major > e.major ? !0 : t.major < e.major ? !1 : t.minor > e.minor ? !0 : t.minor < e.minor ? !1 : t.patch >= e.patch;
var Dl = (e, t) => {
  const n = _r(e), r = _r(t);
  El(n, r) || process.env.NODE_ENV !== "production" && V(`
    React version: [${r.raw}]
    does not satisfy expected peer dependency version: [${n.raw}]

    This can result in run time bugs, and even fatal crashes
  `);
};
const Ft = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var Nl = (e) => {
  const t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && V(`
      No <!doctype html> found.

      ${Ft}
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && V(`
      Unexpected <!doctype> found: (${t.name})

      ${Ft}
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && V(`
      Unexpected <!doctype> publicId found: (${t.publicId})
      A html5 doctype does not have a publicId

      ${Ft}
    `);
};
function Sn(e) {
  process.env.NODE_ENV !== "production" && e();
}
function Ze(e, t) {
  Sn(() => {
    re(() => {
      try {
        e();
      } catch (n) {
        zt(`
          A setup problem was encountered.

          > ${n.message}
        `);
      }
    }, t);
  });
}
function Sl() {
  Ze(() => {
    Dl(vl.react, P.version), Nl(document);
  }, []);
}
function On(e) {
  const t = M(e);
  return re(() => {
    t.current = e;
  }), t;
}
function Ol() {
  let e = null;
  function t() {
    return !!e;
  }
  function n(s) {
    return s === e;
  }
  function r(s) {
    e && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot claim lock as it is already claimed") : g());
    const c = {
      abandon: s
    };
    return e = c, c;
  }
  function o() {
    e || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot release lock when there is no lock") : g()), e = null;
  }
  function i() {
    e && (e.abandon(), o());
  }
  return {
    isClaimed: t,
    isActive: n,
    claim: r,
    release: o,
    tryAbandon: i
  };
}
function qe(e) {
  return e.phase === "IDLE" || e.phase === "DROP_ANIMATING" ? !1 : e.isDragging;
}
const xl = 9, Il = 13, xn = 27, Ho = 32, wl = 33, Cl = 34, _l = 35, Al = 36, Pl = 37, Rl = 38, Tl = 39, Ll = 40, Bl = {
  [Il]: !0,
  [xl]: !0
};
var ko = (e) => {
  Bl[e.keyCode] && e.preventDefault();
};
const Vl = (() => {
  const e = "visibilitychange";
  return typeof document == "undefined" ? e : [e, `ms${e}`, `webkit${e}`, `moz${e}`, `o${e}`].find((r) => `on${r}` in document) || e;
})();
var St = Vl;
const jo = 0, Ar = 5;
function Ml(e, t) {
  return Math.abs(t.x - e.x) >= Ar || Math.abs(t.y - e.y) >= Ar;
}
const Pr = {
  type: "IDLE"
};
function $l({
  cancel: e,
  completed: t,
  getPhase: n,
  setPhase: r
}) {
  return [{
    eventName: "mousemove",
    fn: (o) => {
      const {
        button: i,
        clientX: s,
        clientY: c
      } = o;
      if (i !== jo)
        return;
      const l = {
        x: s,
        y: c
      }, u = n();
      if (u.type === "DRAGGING") {
        o.preventDefault(), u.actions.move(l);
        return;
      }
      u.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot be IDLE") : g());
      const p = u.point;
      if (!Ml(p, l))
        return;
      o.preventDefault();
      const a = u.actions.fluidLift(l);
      r({
        type: "DRAGGING",
        actions: a
      });
    }
  }, {
    eventName: "mouseup",
    fn: (o) => {
      const i = n();
      if (i.type !== "DRAGGING") {
        e();
        return;
      }
      o.preventDefault(), i.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "mousedown",
    fn: (o) => {
      n().type === "DRAGGING" && o.preventDefault(), e();
    }
  }, {
    eventName: "keydown",
    fn: (o) => {
      if (n().type === "PENDING") {
        e();
        return;
      }
      if (o.keyCode === xn) {
        o.preventDefault(), e();
        return;
      }
      ko(o);
    }
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: () => {
      n().type === "PENDING" && e();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: (o) => {
      const i = n();
      if (i.type === "IDLE" && (process.env.NODE_ENV !== "production" ? g(!1, "Unexpected phase") : g()), i.actions.shouldRespectForcePress()) {
        e();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: St,
    fn: e
  }];
}
function Gl(e) {
  const t = M(Pr), n = M(ce), r = A(() => ({
    eventName: "mousedown",
    fn: function(a) {
      if (a.defaultPrevented || a.button !== jo || a.ctrlKey || a.metaKey || a.shiftKey || a.altKey)
        return;
      const d = e.findClosestDraggableId(a);
      if (!d)
        return;
      const f = e.tryGetLock(d, s, {
        sourceEvent: a
      });
      if (!f)
        return;
      a.preventDefault();
      const h = {
        x: a.clientX,
        y: a.clientY
      };
      n.current(), u(f, h);
    }
  }), [e]), o = A(() => ({
    eventName: "webkitmouseforcewillbegin",
    fn: (p) => {
      if (p.defaultPrevented)
        return;
      const a = e.findClosestDraggableId(p);
      if (!a)
        return;
      const d = e.findOptionsForDraggable(a);
      d && (d.shouldRespectForcePress || e.canGetLock(a) && p.preventDefault());
    }
  }), [e]), i = x(function() {
    const a = {
      passive: !1,
      capture: !0
    };
    n.current = ee(window, [o, r], a);
  }, [o, r]), s = x(() => {
    t.current.type !== "IDLE" && (t.current = Pr, n.current(), i());
  }, [i]), c = x(() => {
    const p = t.current;
    s(), p.type === "DRAGGING" && p.actions.cancel({
      shouldBlockNextClick: !0
    }), p.type === "PENDING" && p.actions.abort();
  }, [s]), l = x(function() {
    const a = {
      capture: !0,
      passive: !1
    }, d = $l({
      cancel: c,
      completed: s,
      getPhase: () => t.current,
      setPhase: (f) => {
        t.current = f;
      }
    });
    n.current = ee(window, d, a);
  }, [c, s]), u = x(function(a, d) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? g(!1, "Expected to move from IDLE to PENDING drag") : g()), t.current = {
      type: "PENDING",
      point: d,
      actions: a
    }, l();
  }, [l]);
  K(function() {
    return i(), function() {
      n.current();
    };
  }, [i]);
}
function Fl() {
}
const Wl = {
  [Cl]: !0,
  [wl]: !0,
  [Al]: !0,
  [_l]: !0
};
function Ul(e, t) {
  function n() {
    t(), e.cancel();
  }
  function r() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: (o) => {
      if (o.keyCode === xn) {
        o.preventDefault(), n();
        return;
      }
      if (o.keyCode === Ho) {
        o.preventDefault(), r();
        return;
      }
      if (o.keyCode === Ll) {
        o.preventDefault(), e.moveDown();
        return;
      }
      if (o.keyCode === Rl) {
        o.preventDefault(), e.moveUp();
        return;
      }
      if (o.keyCode === Tl) {
        o.preventDefault(), e.moveRight();
        return;
      }
      if (o.keyCode === Pl) {
        o.preventDefault(), e.moveLeft();
        return;
      }
      if (Wl[o.keyCode]) {
        o.preventDefault();
        return;
      }
      ko(o);
    }
  }, {
    eventName: "mousedown",
    fn: n
  }, {
    eventName: "mouseup",
    fn: n
  }, {
    eventName: "click",
    fn: n
  }, {
    eventName: "touchstart",
    fn: n
  }, {
    eventName: "resize",
    fn: n
  }, {
    eventName: "wheel",
    fn: n,
    options: {
      passive: !0
    }
  }, {
    eventName: St,
    fn: n
  }];
}
function Hl(e) {
  const t = M(Fl), n = A(() => ({
    eventName: "keydown",
    fn: function(i) {
      if (i.defaultPrevented || i.keyCode !== Ho)
        return;
      const s = e.findClosestDraggableId(i);
      if (!s)
        return;
      const c = e.tryGetLock(s, p, {
        sourceEvent: i
      });
      if (!c)
        return;
      i.preventDefault();
      let l = !0;
      const u = c.snapLift();
      t.current();
      function p() {
        l || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot stop capturing a keyboard drag when not capturing") : g()), l = !1, t.current(), r();
      }
      t.current = ee(window, Ul(u, p), {
        capture: !0,
        passive: !1
      });
    }
  }), [e]), r = x(function() {
    const i = {
      passive: !1,
      capture: !0
    };
    t.current = ee(window, [n], i);
  }, [n]);
  K(function() {
    return r(), function() {
      t.current();
    };
  }, [r]);
}
const Wt = {
  type: "IDLE"
}, kl = 120, jl = 0.15;
function ql({
  cancel: e,
  getPhase: t
}) {
  return [{
    eventName: "orientationchange",
    fn: e
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "contextmenu",
    fn: (n) => {
      n.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: (n) => {
      if (t().type !== "DRAGGING") {
        e();
        return;
      }
      n.keyCode === xn && n.preventDefault(), e();
    }
  }, {
    eventName: St,
    fn: e
  }];
}
function zl({
  cancel: e,
  completed: t,
  getPhase: n
}) {
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: (r) => {
      const o = n();
      if (o.type !== "DRAGGING") {
        e();
        return;
      }
      o.hasMoved = !0;
      const {
        clientX: i,
        clientY: s
      } = r.touches[0], c = {
        x: i,
        y: s
      };
      r.preventDefault(), o.actions.move(c);
    }
  }, {
    eventName: "touchend",
    fn: (r) => {
      const o = n();
      if (o.type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "touchcancel",
    fn: (r) => {
      if (n().type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), e();
    }
  }, {
    eventName: "touchforcechange",
    fn: (r) => {
      const o = n();
      o.type === "IDLE" && (process.env.NODE_ENV, g());
      const i = r.touches[0];
      if (!i || !(i.force >= jl))
        return;
      const c = o.actions.shouldRespectForcePress();
      if (o.type === "PENDING") {
        c && e();
        return;
      }
      if (c) {
        if (o.hasMoved) {
          r.preventDefault();
          return;
        }
        e();
        return;
      }
      r.preventDefault();
    }
  }, {
    eventName: St,
    fn: e
  }];
}
function Yl(e) {
  const t = M(Wt), n = M(ce), r = x(function() {
    return t.current;
  }, []), o = x(function(f) {
    t.current = f;
  }, []), i = A(() => ({
    eventName: "touchstart",
    fn: function(f) {
      if (f.defaultPrevented)
        return;
      const h = e.findClosestDraggableId(f);
      if (!h)
        return;
      const b = e.tryGetLock(h, c, {
        sourceEvent: f
      });
      if (!b)
        return;
      const m = f.touches[0], {
        clientX: v,
        clientY: y
      } = m, O = {
        x: v,
        y
      };
      n.current(), a(b, O);
    }
  }), [e]), s = x(function() {
    const f = {
      capture: !0,
      passive: !1
    };
    n.current = ee(window, [i], f);
  }, [i]), c = x(() => {
    const d = t.current;
    d.type !== "IDLE" && (d.type === "PENDING" && clearTimeout(d.longPressTimerId), o(Wt), n.current(), s());
  }, [s, o]), l = x(() => {
    const d = t.current;
    c(), d.type === "DRAGGING" && d.actions.cancel({
      shouldBlockNextClick: !0
    }), d.type === "PENDING" && d.actions.abort();
  }, [c]), u = x(function() {
    const f = {
      capture: !0,
      passive: !1
    }, h = {
      cancel: l,
      completed: c,
      getPhase: r
    }, b = ee(window, zl(h), f), m = ee(window, ql(h), f);
    n.current = function() {
      b(), m();
    };
  }, [l, r, c]), p = x(function() {
    const f = r();
    f.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? g(!1, `Cannot start dragging from phase ${f.type}`) : g());
    const h = f.actions.fluidLift(f.point);
    o({
      type: "DRAGGING",
      actions: h,
      hasMoved: !1
    });
  }, [r, o]), a = x(function(f, h) {
    r().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? g(!1, "Expected to move from IDLE to PENDING drag") : g());
    const b = setTimeout(p, kl);
    o({
      type: "PENDING",
      point: h,
      actions: f,
      longPressTimerId: b
    }), u();
  }, [u, r, o, p]);
  K(function() {
    return s(), function() {
      n.current();
      const h = r();
      h.type === "PENDING" && (clearTimeout(h.longPressTimerId), o(Wt));
    };
  }, [r, s, o]), K(function() {
    return ee(window, [{
      eventName: "touchmove",
      fn: () => {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
  }, []);
}
function Kl(e) {
  Sn(() => {
    const t = On(e);
    Ze(() => {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot change the amount of sensor hooks after mounting") : g(!1));
    });
  });
}
const Xl = ["input", "button", "textarea", "select", "option", "optgroup", "video", "audio"];
function qo(e, t) {
  if (t == null)
    return !1;
  if (Xl.includes(t.tagName.toLowerCase()))
    return !0;
  const r = t.getAttribute("contenteditable");
  return r === "true" || r === "" ? !0 : t === e ? !1 : qo(e, t.parentElement);
}
function Jl(e, t) {
  const n = t.target;
  return Je(n) ? qo(e, n) : !1;
}
var Zl = (e) => ne(e.getBoundingClientRect()).center;
function Ql(e) {
  return e instanceof Fo(e).Element;
}
const eu = (() => {
  const e = "matches";
  return typeof document == "undefined" ? e : [e, "msMatchesSelector", "webkitMatchesSelector"].find((r) => r in Element.prototype) || e;
})();
function zo(e, t) {
  return e == null ? null : e[eu](t) ? e : zo(e.parentElement, t);
}
function tu(e, t) {
  return e.closest ? e.closest(t) : zo(e, t);
}
function nu(e) {
  return `[${De.contextId}="${e}"]`;
}
function ru(e, t) {
  const n = t.target;
  if (!Ql(n))
    return process.env.NODE_ENV !== "production" && V("event.target must be a Element"), null;
  const r = nu(e), o = tu(n, r);
  return o ? Je(o) ? o : (process.env.NODE_ENV !== "production" && V("drag handle must be a HTMLElement"), null) : null;
}
function ou(e, t) {
  const n = ru(e, t);
  return n ? n.getAttribute(De.draggableId) : null;
}
function iu(e, t) {
  const n = `[${Zt.contextId}="${e}"]`, o = Go(document, n).find((i) => i.getAttribute(Zt.id) === t);
  return o ? Je(o) ? o : (process.env.NODE_ENV !== "production" && V("Draggable element is not a HTMLElement"), null) : null;
}
function su(e) {
  e.preventDefault();
}
function at({
  expected: e,
  phase: t,
  isLockActive: n,
  shouldWarn: r
}) {
  return n() ? e !== t ? (r && process.env.NODE_ENV !== "production" && V(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ${e}
        You called an action from outdated phase: ${t}

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (r && process.env.NODE_ENV !== "production" && V(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function Yo({
  lockAPI: e,
  store: t,
  registry: n,
  draggableId: r
}) {
  if (e.isClaimed())
    return !1;
  const o = n.draggable.findById(r);
  return o ? !(!o.options.isEnabled || !Bo(t.getState(), r)) : (process.env.NODE_ENV !== "production" && V(`Unable to find draggable with id: ${r}`), !1);
}
function cu({
  lockAPI: e,
  contextId: t,
  store: n,
  registry: r,
  draggableId: o,
  forceSensorStop: i,
  sourceEvent: s
}) {
  if (!Yo({
    lockAPI: e,
    store: n,
    registry: r,
    draggableId: o
  }))
    return null;
  const l = r.draggable.getById(o), u = iu(t, l.descriptor.id);
  if (!u)
    return process.env.NODE_ENV !== "production" && V(`Unable to find draggable element with id: ${o}`), null;
  if (s && !l.options.canDragInteractiveElements && Jl(u, s))
    return null;
  const p = e.claim(i || ce);
  let a = "PRE_DRAG";
  function d() {
    return l.options.shouldRespectForcePress;
  }
  function f() {
    return e.isActive(p);
  }
  function h(S, E) {
    at({
      expected: S,
      phase: a,
      isLockActive: f,
      shouldWarn: !0
    }) && n.dispatch(E());
  }
  const b = h.bind(null, "DRAGGING");
  function m(S) {
    function E() {
      e.release(), a = "COMPLETED";
    }
    a !== "PRE_DRAG" && (E(), process.env.NODE_ENV !== "production" ? g(!1, `Cannot lift in phase ${a}`) : g()), n.dispatch(Mc(S.liftActionArgs)), a = "DRAGGING";
    function w(_, H = {
      shouldBlockNextClick: !1
    }) {
      if (S.cleanup(), H.shouldBlockNextClick) {
        const B = ee(window, [{
          eventName: "click",
          fn: su,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(B);
      }
      E(), n.dispatch(wo({
        reason: _
      }));
    }
    return N({
      isActive: () => at({
        expected: "DRAGGING",
        phase: a,
        isLockActive: f,
        shouldWarn: !1
      }),
      shouldRespectForcePress: d,
      drop: (_) => w("DROP", _),
      cancel: (_) => w("CANCEL", _)
    }, S.actions);
  }
  function v(S) {
    const E = $e((_) => {
      b(() => Io({
        client: _
      }));
    }), w = m({
      liftActionArgs: {
        id: o,
        clientSelection: S,
        movementMode: "FLUID"
      },
      cleanup: () => E.cancel(),
      actions: {
        move: E
      }
    });
    return C(N({}, w), {
      move: E
    });
  }
  function y() {
    const S = {
      moveUp: () => b(qc),
      moveRight: () => b(Yc),
      moveDown: () => b(zc),
      moveLeft: () => b(Kc)
    };
    return m({
      liftActionArgs: {
        id: o,
        clientSelection: Zl(u),
        movementMode: "SNAP"
      },
      cleanup: ce,
      actions: S
    });
  }
  function O() {
    at({
      expected: "PRE_DRAG",
      phase: a,
      isLockActive: f,
      shouldWarn: !0
    }) && e.release();
  }
  return {
    isActive: () => at({
      expected: "PRE_DRAG",
      phase: a,
      isLockActive: f,
      shouldWarn: !1
    }),
    shouldRespectForcePress: d,
    fluidLift: v,
    snapLift: y,
    abort: O
  };
}
const au = [Gl, Hl, Yl];
function lu({
  contextId: e,
  store: t,
  registry: n,
  customSensors: r,
  enableDefaultSensors: o
}) {
  const i = [...o ? au : [], ...r || []], s = en(() => Ol())[0], c = x(function(m, v) {
    qe(m) && !qe(v) && s.tryAbandon();
  }, [s]);
  K(function() {
    let m = t.getState();
    return t.subscribe(() => {
      const y = t.getState();
      c(m, y), m = y;
    });
  }, [s, t, c]), K(() => s.tryAbandon, [s.tryAbandon]);
  const l = x((b) => Yo({
    lockAPI: s,
    registry: n,
    store: t,
    draggableId: b
  }), [s, n, t]), u = x((b, m, v) => cu({
    lockAPI: s,
    registry: n,
    contextId: e,
    store: t,
    draggableId: b,
    forceSensorStop: m || null,
    sourceEvent: v && v.sourceEvent ? v.sourceEvent : null
  }), [e, s, n, t]), p = x((b) => ou(e, b), [e]), a = x((b) => {
    const m = n.draggable.findById(b);
    return m ? m.options : null;
  }, [n.draggable]), d = x(function() {
    s.isClaimed() && (s.tryAbandon(), t.getState().phase !== "IDLE" && t.dispatch(gn()));
  }, [s, t]), f = x(() => s.isClaimed(), [s]), h = A(() => ({
    canGetLock: l,
    tryGetLock: u,
    findClosestDraggableId: p,
    findOptionsForDraggable: a,
    tryReleaseLock: d,
    isLockClaimed: f
  }), [l, u, p, a, d, f]);
  Kl(i);
  for (let b = 0; b < i.length; b++)
    i[b](h);
}
const uu = (e) => ({
  onBeforeCapture: (t) => {
    const n = () => {
      e.onBeforeCapture && e.onBeforeCapture(t);
    };
    P.version.startsWith("16") || P.version.startsWith("17") ? n() : Ur(n);
  },
  onBeforeDragStart: e.onBeforeDragStart,
  onDragStart: e.onDragStart,
  onDragEnd: e.onDragEnd,
  onDragUpdate: e.onDragUpdate
}), du = (e) => C(N(N({}, ke), e.autoScrollerOptions), {
  durationDampening: N(N({}, ke.durationDampening), e.autoScrollerOptions)
});
function Le(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? g(!1, "Could not find store from lazy ref") : g()), e.current;
}
function pu(e) {
  const {
    contextId: t,
    setCallbacks: n,
    sensors: r,
    nonce: o,
    dragHandleUsageInstructions: i
  } = e, s = M(null);
  Sl();
  const c = On(e), l = x(() => uu(c.current), [c]), u = x(() => du(c.current), [c]), p = pl(t), a = hl({
    contextId: t,
    text: i
  }), d = il(t, o), f = x((B) => {
    Le(s).dispatch(B);
  }, []), h = A(() => Un({
    publishWhileDragging: Gc,
    updateDroppableScroll: Wc,
    updateDroppableIsEnabled: Uc,
    updateDroppableIsCombineEnabled: Hc,
    collectionStarting: Fc
  }, f), [f]), b = al(), m = A(() => Va(b, h), [b, h]), v = A(() => Qa(N({
    scrollWindow: Ma,
    scrollDroppable: m.scrollDroppable,
    getAutoScrollerOptions: u
  }, Un({
    move: Io
  }, f))), [m.scrollDroppable, f, u]), y = sl(t), O = A(() => Ra({
    announce: p,
    autoScroller: v,
    dimensionMarshal: m,
    focusMarshal: y,
    getResponders: l,
    styleMarshal: d
  }), [p, v, m, y, l, d]);
  process.env.NODE_ENV !== "production" && s.current && s.current !== O && process.env.NODE_ENV !== "production" && V("unexpected store change"), s.current = O;
  const D = x(() => {
    const B = Le(s);
    B.getState().phase !== "IDLE" && B.dispatch(gn());
  }, []), S = x(() => {
    const B = Le(s).getState();
    return B.phase === "DROP_ANIMATING" ? !0 : B.phase === "IDLE" ? !1 : B.isDragging;
  }, []), E = A(() => ({
    isDragging: S,
    tryAbort: D
  }), [S, D]);
  n(E);
  const w = x((B) => Bo(Le(s).getState(), B), []), _ = x(() => ge(Le(s).getState()), []), H = A(() => ({
    marshal: m,
    focus: y,
    contextId: t,
    canLift: w,
    isMovementAllowed: _,
    dragHandleUsageInstructionsId: a,
    registry: b
  }), [t, m, a, y, w, _, b]);
  return lu({
    contextId: t,
    store: O,
    registry: b,
    customSensors: r || null,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), re(() => D, [D]), P.createElement(Nt.Provider, {
    value: H
  }, P.createElement(ls, {
    context: Dn,
    store: O
  }, e.children));
}
let fu = 0;
function gu() {
  return A(() => `${fu++}`, []);
}
function mu() {
  return P.useId();
}
var bu = "useId" in P ? mu : gu;
function Rr(e) {
  const t = bu(), n = e.dragHandleUsageInstructions || dt.dragHandleUsageInstructions;
  return P.createElement(xs, null, (r) => P.createElement(pu, {
    nonce: e.nonce,
    contextId: t,
    setCallbacks: r,
    dragHandleUsageInstructions: n,
    enableDefaultSensors: e.enableDefaultSensors,
    sensors: e.sensors,
    onBeforeCapture: e.onBeforeCapture,
    onBeforeDragStart: e.onBeforeDragStart,
    onDragStart: e.onDragStart,
    onDragUpdate: e.onDragUpdate,
    onDragEnd: e.onDragEnd,
    autoScrollerOptions: e.autoScrollerOptions
  }, e.children));
}
const Tr = {
  dragging: 5e3,
  dropAnimating: 4500
}, hu = (e, t) => t ? Ve.drop(t.duration) : e ? Ve.snap : Ve.fluid, vu = (e, t) => {
  if (e)
    return t ? He.opacity.drop : He.opacity.combining;
}, yu = (e) => e.forceShouldAnimate != null ? e.forceShouldAnimate : e.mode === "SNAP";
function Eu(e) {
  const n = e.dimension.client, {
    offset: r,
    combineWith: o,
    dropping: i
  } = e, s = !!o, c = yu(e), l = !!i, u = l ? Xt.drop(r, s) : Xt.moveTo(r);
  return {
    position: "fixed",
    top: n.marginBox.top,
    left: n.marginBox.left,
    boxSizing: "border-box",
    width: n.borderBox.width,
    height: n.borderBox.height,
    transition: hu(c, i),
    transform: u,
    opacity: vu(s, l),
    zIndex: l ? Tr.dropAnimating : Tr.dragging,
    pointerEvents: "none"
  };
}
function Du(e) {
  return {
    transform: Xt.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? void 0 : "none"
  };
}
function Nu(e) {
  return e.type === "DRAGGING" ? Eu(e) : Du(e);
}
function Su(e, t, n = F) {
  const r = window.getComputedStyle(t), o = t.getBoundingClientRect(), i = eo(o, r), s = gt(i, n), c = {
    client: i,
    tagName: t.tagName.toLowerCase(),
    display: r.display
  }, l = {
    x: i.marginBox.width,
    y: i.marginBox.height
  };
  return {
    descriptor: e,
    placeholder: c,
    displaceBy: l,
    client: i,
    page: s
  };
}
function Ou(e) {
  const t = Nn("draggable"), {
    descriptor: n,
    registry: r,
    getDraggableRef: o,
    canDragInteractiveElements: i,
    shouldRespectForcePress: s,
    isEnabled: c
  } = e, l = A(() => ({
    canDragInteractiveElements: i,
    shouldRespectForcePress: s,
    isEnabled: c
  }), [i, c, s]), u = x((f) => {
    const h = o();
    return h || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot get dimension when no ref is set") : g()), Su(n, h, f);
  }, [n, o]), p = A(() => ({
    uniqueId: t,
    descriptor: n,
    options: l,
    getDimension: u
  }), [n, u, l, t]), a = M(p), d = M(!0);
  K(() => (r.draggable.register(a.current), () => r.draggable.unregister(a.current)), [r.draggable]), K(() => {
    if (d.current) {
      d.current = !1;
      return;
    }
    const f = a.current;
    a.current = p, r.draggable.update(p, f);
  }, [p, r.draggable]);
}
var In = P.createContext(null);
function Ko(e) {
  e && Je(e) || (process.env.NODE_ENV !== "production" ? g(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/hello-pangea/dnd/blob/main/docs/guides/using-inner-ref.md
  `) : g());
}
function xu(e, t, n) {
  Ze(() => {
    function r(i) {
      return `Draggable[id: ${i}]: `;
    }
    const o = e.draggableId;
    o || (process.env.NODE_ENV !== "production" ? g(!1, "Draggable requires a draggableId") : g(!1)), typeof o != "string" && (process.env.NODE_ENV !== "production" ? g(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ${typeof o}] (value: ${o})`) : g(!1)), Number.isInteger(e.index) || (process.env.NODE_ENV !== "production" ? g(!1, `${r(o)} requires an integer index prop`) : g(!1)), e.mapped.type !== "DRAGGING" && (Ko(n()), e.isEnabled && (Wo(t, o) || (process.env.NODE_ENV !== "production" ? g(!1, `${r(o)} Unable to find drag handle`) : g(!1))));
  });
}
function Iu(e) {
  Sn(() => {
    const t = M(e);
    Ze(() => {
      e !== t.current && (process.env.NODE_ENV !== "production" ? g(!1, "Draggable isClone prop value changed during component life") : g(!1));
    }, [e]);
  });
}
function ht(e) {
  const t = Wr(e);
  return t || (process.env.NODE_ENV !== "production" ? g(!1, "Could not find required context") : g()), t;
}
function wu(e) {
  e.preventDefault();
}
const Cu = (e) => {
  const t = M(null), n = x((E = null) => {
    t.current = E;
  }, []), r = x(() => t.current, []), {
    contextId: o,
    dragHandleUsageInstructionsId: i,
    registry: s
  } = ht(Nt), {
    type: c,
    droppableId: l
  } = ht(In), u = A(() => ({
    id: e.draggableId,
    index: e.index,
    type: c,
    droppableId: l
  }), [e.draggableId, e.index, c, l]), {
    children: p,
    draggableId: a,
    isEnabled: d,
    shouldRespectForcePress: f,
    canDragInteractiveElements: h,
    isClone: b,
    mapped: m,
    dropAnimationFinished: v
  } = e;
  if (xu(e, o, r), Iu(b), !b) {
    const E = A(() => ({
      descriptor: u,
      registry: s,
      getDraggableRef: r,
      canDragInteractiveElements: h,
      shouldRespectForcePress: f,
      isEnabled: d
    }), [u, s, r, h, f, d]);
    Ou(E);
  }
  const y = A(() => d ? {
    tabIndex: 0,
    role: "button",
    "aria-describedby": i,
    "data-rfd-drag-handle-draggable-id": a,
    "data-rfd-drag-handle-context-id": o,
    draggable: !1,
    onDragStart: wu
  } : null, [o, i, a, d]), O = x((E) => {
    m.type === "DRAGGING" && m.dropping && E.propertyName === "transform" && (P.version.startsWith("16") || P.version.startsWith("17") ? v() : Ur(v));
  }, [v, m]), D = A(() => {
    const E = Nu(m), w = m.type === "DRAGGING" && m.dropping ? O : void 0;
    return {
      innerRef: n,
      draggableProps: {
        "data-rfd-draggable-context-id": o,
        "data-rfd-draggable-id": a,
        style: E,
        onTransitionEnd: w
      },
      dragHandleProps: y
    };
  }, [o, y, a, m, O, n]), S = A(() => ({
    draggableId: u.id,
    type: u.type,
    source: {
      index: u.index,
      droppableId: u.droppableId
    }
  }), [u.droppableId, u.id, u.index, u.type]);
  return P.createElement(P.Fragment, null, p(D, m.snapshot, S));
};
var _u = Cu, Xo = (e, t) => e === t, Jo = (e) => {
  const {
    combine: t,
    destination: n
  } = e;
  return n ? n.droppableId : t ? t.droppableId : null;
};
const Au = (e) => e.combine ? e.combine.draggableId : null, Pu = (e) => e.at && e.at.type === "COMBINE" ? e.at.combine.draggableId : null;
function Ru() {
  const e = G((o, i) => ({
    x: o,
    y: i
  })), t = G((o, i, s = null, c = null, l = null) => ({
    isDragging: !0,
    isClone: i,
    isDropAnimating: !!l,
    dropAnimation: l,
    mode: o,
    draggingOver: s,
    combineWith: c,
    combineTargetFor: null
  })), n = G((o, i, s, c, l = null, u = null, p = null) => ({
    mapped: {
      type: "DRAGGING",
      dropping: null,
      draggingOver: l,
      combineWith: u,
      mode: i,
      offset: o,
      dimension: s,
      forceShouldAnimate: p,
      snapshot: t(i, c, l, u, null)
    }
  }));
  return (o, i) => {
    if (qe(o)) {
      if (o.critical.draggable.id !== i.draggableId)
        return null;
      const s = o.current.client.offset, c = o.dimensions.draggables[i.draggableId], l = Y(o.impact), u = Pu(o.impact), p = o.forceShouldAnimate;
      return n(e(s.x, s.y), o.movementMode, c, i.isClone, l, u, p);
    }
    if (o.phase === "DROP_ANIMATING") {
      const s = o.completed;
      if (s.result.draggableId !== i.draggableId)
        return null;
      const c = i.isClone, l = o.dimensions.draggables[i.draggableId], u = s.result, p = u.mode, a = Jo(u), d = Au(u), h = {
        duration: o.dropDuration,
        curve: bn.drop,
        moveTo: o.newHomeClientOffset,
        opacity: d ? He.opacity.drop : null,
        scale: d ? He.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: o.newHomeClientOffset,
          dimension: l,
          dropping: h,
          draggingOver: a,
          combineWith: d,
          mode: p,
          forceShouldAnimate: null,
          snapshot: t(p, c, a, d, h)
        }
      };
    }
    return null;
  };
}
function Zo(e = null) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
const Tu = {
  mapped: {
    type: "SECONDARY",
    offset: F,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: Zo(null)
  }
};
function Lu() {
  const e = G((s, c) => ({
    x: s,
    y: c
  })), t = G(Zo), n = G((s, c = null, l) => ({
    mapped: {
      type: "SECONDARY",
      offset: s,
      combineTargetFor: c,
      shouldAnimateDisplacement: l,
      snapshot: t(c)
    }
  })), r = (s) => s ? n(F, s, !0) : null, o = (s, c, l, u) => {
    const p = l.displaced.visible[s], a = !!(u.inVirtualList && u.effected[s]), d = yt(l), f = d && d.draggableId === s ? c : null;
    if (!p) {
      if (!a)
        return r(f);
      if (l.displaced.invisible[s])
        return null;
      const m = Ne(u.displacedBy.point), v = e(m.x, m.y);
      return n(v, f, !0);
    }
    if (a)
      return r(f);
    const h = l.displacedBy.point, b = e(h.x, h.y);
    return n(b, f, p.shouldAnimate);
  };
  return (s, c) => {
    if (qe(s))
      return s.critical.draggable.id === c.draggableId ? null : o(c.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      const l = s.completed;
      return l.result.draggableId === c.draggableId ? null : o(c.draggableId, l.result.draggableId, l.impact, l.afterCritical);
    }
    return null;
  };
}
const Bu = () => {
  const e = Ru(), t = Lu();
  return (r, o) => e(r, o) || t(r, o) || Tu;
}, Vu = {
  dropAnimationFinished: Co
}, Mu = Zr(Bu, Vu, null, {
  context: Dn,
  areStatePropsEqual: Xo
})(_u);
var $u = Mu;
function Qo(e) {
  return ht(In).isUsingCloneFor === e.draggableId && !e.isClone ? null : P.createElement($u, e);
}
function Lr(e) {
  const t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, n = !!e.disableInteractiveElementBlocking, r = !!e.shouldRespectForcePress;
  return P.createElement(Qo, se({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: n,
    shouldRespectForcePress: r
  }));
}
const wn = (e) => (t) => e === t, Gu = wn("scroll"), Fu = wn("auto"), Wu = wn("visible"), Br = (e, t) => t(e.overflowX) || t(e.overflowY), Uu = (e, t) => t(e.overflowX) && t(e.overflowY), ei = (e) => {
  const t = window.getComputedStyle(e), n = {
    overflowX: t.overflowX,
    overflowY: t.overflowY
  };
  return Br(n, Gu) || Br(n, Fu);
}, Hu = () => {
  if (process.env.NODE_ENV === "production")
    return !1;
  const e = je(), t = document.documentElement;
  if (t || (process.env.NODE_ENV, g()), !ei(e))
    return !1;
  const n = window.getComputedStyle(t), r = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return Uu(r, Wu) || process.env.NODE_ENV !== "production" && V(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Cn = (e) => e == null ? null : e === document.body ? Hu() ? e : null : e === document.documentElement ? null : ei(e) ? e : Cn(e.parentElement);
var ku = (e) => {
  !e || !Cn(e.parentElement) || process.env.NODE_ENV !== "production" && V(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
}, Qt = (e) => ({
  x: e.scrollLeft,
  y: e.scrollTop
});
const ti = (e) => e ? window.getComputedStyle(e).position === "fixed" ? !0 : ti(e.parentElement) : !1;
var ju = (e) => {
  const t = Cn(e), n = ti(e);
  return {
    closestScrollable: t,
    isFixedOnPage: n
  };
}, qu = ({
  descriptor: e,
  isEnabled: t,
  isCombineEnabled: n,
  isFixedOnPage: r,
  direction: o,
  client: i,
  page: s,
  closest: c
}) => {
  const l = (() => {
    if (!c)
      return null;
    const {
      scrollSize: d,
      client: f
    } = c, h = Ro({
      scrollHeight: d.scrollHeight,
      scrollWidth: d.scrollWidth,
      height: f.paddingBox.height,
      width: f.paddingBox.width
    });
    return {
      pageMarginBox: c.page.marginBox,
      frameClient: f,
      scrollSize: d,
      shouldClipSubject: c.shouldClipSubject,
      scroll: {
        initial: c.scroll,
        current: c.scroll,
        max: h,
        diff: {
          value: F,
          displacement: F
        }
      }
    };
  })(), u = o === "vertical" ? ln : uo, p = ye({
    page: s,
    withPlaceholder: null,
    axis: u,
    frame: l
  });
  return {
    descriptor: e,
    isCombineEnabled: n,
    isFixedOnPage: r,
    axis: u,
    isEnabled: t,
    client: i,
    page: s,
    frame: l,
    subject: p
  };
};
const zu = (e, t) => {
  const n = to(e);
  if (!t || e !== t)
    return n;
  const r = n.paddingBox.top - t.scrollTop, o = n.paddingBox.left - t.scrollLeft, i = r + t.scrollHeight, s = o + t.scrollWidth, l = on({
    top: r,
    right: s,
    bottom: i,
    left: o
  }, n.border);
  return sn({
    borderBox: l,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
};
var Yu = ({
  ref: e,
  descriptor: t,
  env: n,
  windowScroll: r,
  direction: o,
  isDropDisabled: i,
  isCombineEnabled: s,
  shouldClipSubject: c
}) => {
  const l = n.closestScrollable, u = zu(e, l), p = gt(u, r), a = (() => {
    if (!l)
      return null;
    const f = to(l), h = {
      scrollHeight: l.scrollHeight,
      scrollWidth: l.scrollWidth
    };
    return {
      client: f,
      page: gt(f, r),
      scroll: Qt(l),
      scrollSize: h,
      shouldClipSubject: c
    };
  })();
  return qu({
    descriptor: t,
    isEnabled: !i,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: o,
    client: u,
    page: p,
    closest: a
  });
};
const Ku = {
  passive: !1
}, Xu = {
  passive: !0
};
var Vr = (e) => e.shouldPublishImmediately ? Ku : Xu;
const lt = (e) => e && e.env.closestScrollable || null;
function Ju(e) {
  const t = M(null), n = ht(Nt), r = Nn("droppable"), {
    registry: o,
    marshal: i
  } = n, s = On(e), c = A(() => ({
    id: e.droppableId,
    type: e.type,
    mode: e.mode
  }), [e.droppableId, e.mode, e.type]), l = M(c), u = A(() => G((D, S) => {
    t.current || (process.env.NODE_ENV !== "production" ? g(!1, "Can only update scroll when dragging") : g());
    const E = {
      x: D,
      y: S
    };
    i.updateDroppableScroll(c.id, E);
  }), [c.id, i]), p = x(() => {
    const D = t.current;
    return !D || !D.env.closestScrollable ? F : Qt(D.env.closestScrollable);
  }, []), a = x(() => {
    const D = p();
    u(D.x, D.y);
  }, [p, u]), d = A(() => $e(a), [a]), f = x(() => {
    const D = t.current, S = lt(D);
    if (D && S || (process.env.NODE_ENV !== "production" ? g(!1, "Could not find scroll options while scrolling") : g()), D.scrollOptions.shouldPublishImmediately) {
      a();
      return;
    }
    d();
  }, [d, a]), h = x((D, S) => {
    t.current && (process.env.NODE_ENV !== "production" ? g(!1, "Cannot collect a droppable while a drag is occurring") : g());
    const E = s.current, w = E.getDroppableRef();
    w || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot collect without a droppable ref") : g());
    const _ = ju(w), H = {
      ref: w,
      descriptor: c,
      env: _,
      scrollOptions: S
    };
    t.current = H;
    const B = Yu({
      ref: w,
      descriptor: c,
      env: _,
      windowScroll: D,
      direction: E.direction,
      isDropDisabled: E.isDropDisabled,
      isCombineEnabled: E.isCombineEnabled,
      shouldClipSubject: !E.ignoreContainerClipping
    }), k = _.closestScrollable;
    return k && (k.setAttribute(wr.contextId, n.contextId), k.addEventListener("scroll", f, Vr(H.scrollOptions)), process.env.NODE_ENV !== "production" && ku(k)), B;
  }, [n.contextId, c, f, s]), b = x(() => {
    const D = t.current, S = lt(D);
    return D && S || (process.env.NODE_ENV !== "production" ? g(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : g()), Qt(S);
  }, []), m = x(() => {
    const D = t.current;
    D || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot stop drag when no active drag") : g());
    const S = lt(D);
    t.current = null, S && (d.cancel(), S.removeAttribute(wr.contextId), S.removeEventListener("scroll", f, Vr(D.scrollOptions)));
  }, [f, d]), v = x((D) => {
    const S = t.current;
    S || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot scroll when there is no drag") : g());
    const E = lt(S);
    E || (process.env.NODE_ENV !== "production" ? g(!1, "Cannot scroll a droppable with no closest scrollable") : g()), E.scrollTop += D.y, E.scrollLeft += D.x;
  }, []), y = A(() => ({
    getDimensionAndWatchScroll: h,
    getScrollWhileDragging: b,
    dragStopped: m,
    scroll: v
  }), [m, h, b, v]), O = A(() => ({
    uniqueId: r,
    descriptor: c,
    callbacks: y
  }), [y, c, r]);
  K(() => (l.current = O.descriptor, o.droppable.register(O), () => {
    t.current && (process.env.NODE_ENV !== "production" && V("Unsupported: changing the droppableId or type of a Droppable during a drag"), m()), o.droppable.unregister(O);
  }), [y, c, m, O, i, o.droppable]), K(() => {
    t.current && i.updateDroppableIsEnabled(l.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, i]), K(() => {
    t.current && i.updateDroppableIsCombineEnabled(l.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, i]);
}
function Ut() {
}
const Mr = {
  width: 0,
  height: 0,
  margin: Rs
}, Zu = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: n
}) => e || n === "close" ? Mr : {
  height: t.client.borderBox.height,
  width: t.client.borderBox.width,
  margin: t.client.margin
}, Qu = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: n
}) => {
  const r = Zu({
    isAnimatingOpenOnMount: e,
    placeholder: t,
    animate: n
  });
  return {
    display: t.display,
    boxSizing: "border-box",
    width: r.width,
    height: r.height,
    marginTop: r.margin.top,
    marginRight: r.margin.right,
    marginBottom: r.margin.bottom,
    marginLeft: r.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: n !== "none" ? Ve.placeholder : null
  };
}, ed = (e) => {
  const t = M(null), n = x(() => {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), {
    animate: r,
    onTransitionEnd: o,
    onClose: i,
    contextId: s
  } = e, [c, l] = en(e.animate === "open");
  re(() => c ? r !== "open" ? (n(), l(!1), Ut) : t.current ? Ut : (t.current = setTimeout(() => {
    t.current = null, l(!1);
  }), n) : Ut, [r, c, n]);
  const u = x((a) => {
    a.propertyName === "height" && (o(), r === "close" && i());
  }, [r, i, o]), p = Qu({
    isAnimatingOpenOnMount: c,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return P.createElement(e.placeholder.tagName, {
    style: p,
    "data-rfd-placeholder-context-id": s,
    onTransitionEnd: u,
    ref: e.innerRef
  });
};
var td = P.memo(ed);
function Ht(e) {
  return typeof e == "boolean";
}
function kt(e, t) {
  t.forEach((n) => n(e));
}
const nd = [function({
  props: t
}) {
  t.droppableId || (process.env.NODE_ENV !== "production" ? g(!1, "A Droppable requires a droppableId prop") : g()), typeof t.droppableId != "string" && (process.env.NODE_ENV !== "production" ? g(!1, `A Droppable requires a [string] droppableId. Provided: [${typeof t.droppableId}]`) : g());
}, function({
  props: t
}) {
  Ht(t.isDropDisabled) || (process.env.NODE_ENV !== "production" ? g(!1, "isDropDisabled must be a boolean") : g()), Ht(t.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? g(!1, "isCombineEnabled must be a boolean") : g()), Ht(t.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? g(!1, "ignoreContainerClipping must be a boolean") : g());
}, function({
  getDroppableRef: t
}) {
  Ko(t());
}], rd = [function({
  props: t,
  getPlaceholderRef: n
}) {
  !t.placeholder || n() || process.env.NODE_ENV !== "production" && V(`
      Droppable setup issue [droppableId: "${t.droppableId}"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/hello-pangea/dnd/blob/main/docs/api/droppable.md
    `);
}], od = [function({
  props: t
}) {
  t.renderClone || (process.env.NODE_ENV !== "production" ? g(!1, "Must provide a clone render function (renderClone) for virtual lists") : g());
}, function({
  getPlaceholderRef: t
}) {
  t() && (process.env.NODE_ENV !== "production" ? g(!1, "Expected virtual list to not have a placeholder") : g());
}];
function id(e) {
  Ze(() => {
    kt(e, nd), e.props.mode === "standard" && kt(e, rd), e.props.mode === "virtual" && kt(e, od);
  });
}
class sd extends P.PureComponent {
  constructor(...t) {
    super(...t), this.state = {
      isVisible: !!this.props.on,
      data: this.props.on,
      animate: this.props.shouldAnimate && this.props.on ? "open" : "none"
    }, this.onClose = () => {
      this.state.animate === "close" && this.setState({
        isVisible: !1
      });
    };
  }
  static getDerivedStateFromProps(t, n) {
    return t.shouldAnimate ? t.on ? {
      isVisible: !0,
      data: t.on,
      animate: "open"
    } : n.isVisible ? {
      isVisible: !0,
      data: n.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!t.on,
      data: t.on,
      animate: "none"
    };
  }
  render() {
    if (!this.state.isVisible)
      return null;
    const t = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(t);
  }
}
const cd = (e) => {
  const t = Wr(Nt);
  t || (process.env.NODE_ENV !== "production" ? g(!1, "Could not find app context") : g());
  const {
    contextId: n,
    isMovementAllowed: r
  } = t, o = M(null), i = M(null), {
    children: s,
    droppableId: c,
    type: l,
    mode: u,
    direction: p,
    ignoreContainerClipping: a,
    isDropDisabled: d,
    isCombineEnabled: f,
    snapshot: h,
    useClone: b,
    updateViewportMaxScroll: m,
    getContainerForClone: v
  } = e, y = x(() => o.current, []), O = x(($ = null) => {
    o.current = $;
  }, []), D = x(() => i.current, []), S = x(($ = null) => {
    i.current = $;
  }, []);
  id({
    props: e,
    getDroppableRef: y,
    getPlaceholderRef: D
  });
  const E = x(() => {
    r() && m({
      maxScroll: Lo()
    });
  }, [r, m]);
  Ju({
    droppableId: c,
    type: l,
    mode: u,
    direction: p,
    isDropDisabled: d,
    isCombineEnabled: f,
    ignoreContainerClipping: a,
    getDroppableRef: y
  });
  const w = A(() => P.createElement(sd, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, ({
    onClose: $,
    data: X,
    animate: oe
  }) => P.createElement(td, {
    placeholder: X,
    onClose: $,
    innerRef: S,
    animate: oe,
    contextId: n,
    onTransitionEnd: E
  })), [n, E, e.placeholder, e.shouldAnimatePlaceholder, S]), _ = A(() => ({
    innerRef: O,
    placeholder: w,
    droppableProps: {
      "data-rfd-droppable-id": c,
      "data-rfd-droppable-context-id": n
    }
  }), [n, c, w, O]), H = b ? b.dragging.draggableId : null, B = A(() => ({
    droppableId: c,
    type: l,
    isUsingCloneFor: H
  }), [c, H, l]);
  function k() {
    if (!b)
      return null;
    const {
      dragging: $,
      render: X
    } = b, oe = P.createElement(Qo, {
      draggableId: $.draggableId,
      index: $.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, (J, he) => X(J, he, $));
    return ui.createPortal(oe, v());
  }
  return P.createElement(In.Provider, {
    value: B
  }, s(_, h), k());
};
var ad = cd;
function ld() {
  return document.body || (process.env.NODE_ENV !== "production" ? g(!1, "document.body is not ready") : g()), document.body;
}
const $r = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: ld
}, ni = (e) => {
  let t = N({}, e), n;
  for (n in $r)
    e[n] === void 0 && (t = C(N({}, t), {
      [n]: $r[n]
    }));
  return t;
}, jt = (e, t) => e === t.droppable.type, Gr = (e, t) => t.draggables[e.draggable.id], ud = () => {
  const e = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, t = C(N({}, e), {
    shouldAnimatePlaceholder: !1
  }), n = G((i) => ({
    draggableId: i.id,
    type: i.type,
    source: {
      index: i.index,
      droppableId: i.droppableId
    }
  })), r = G((i, s, c, l, u, p) => {
    const a = u.descriptor.id;
    if (u.descriptor.droppableId === i) {
      const h = p ? {
        render: p,
        dragging: n(u.descriptor)
      } : null, b = {
        isDraggingOver: c,
        draggingOverWith: c ? a : null,
        draggingFromThisWith: a,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: u.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: b,
        useClone: h
      };
    }
    if (!s)
      return t;
    if (!l)
      return e;
    const f = {
      isDraggingOver: c,
      draggingOverWith: a,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: u.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: f,
      useClone: null
    };
  });
  return (i, s) => {
    const c = ni(s), l = c.droppableId, u = c.type, p = !c.isDropDisabled, a = c.renderClone;
    if (qe(i)) {
      const d = i.critical;
      if (!jt(u, d))
        return t;
      const f = Gr(d, i.dimensions), h = Y(i.impact) === l;
      return r(l, p, h, h, f, a);
    }
    if (i.phase === "DROP_ANIMATING") {
      const d = i.completed;
      if (!jt(u, d.critical))
        return t;
      const f = Gr(d.critical, i.dimensions);
      return r(l, p, Jo(d.result) === l, Y(d.impact) === l, f, a);
    }
    if (i.phase === "IDLE" && i.completed && !i.shouldFlush) {
      const d = i.completed;
      if (!jt(u, d.critical))
        return t;
      const f = Y(d.impact) === l, h = !!(d.impact.at && d.impact.at.type === "COMBINE"), b = d.critical.droppable.id === l;
      return f ? h ? e : t : b ? e : t;
    }
    return t;
  };
}, dd = {
  updateViewportMaxScroll: jc
}, pd = Zr(ud, dd, (e, t, n) => N(N(N({}, ni(n)), e), t), {
  context: Dn,
  areStatePropsEqual: Xo
})(ad);
var Fr = pd;
const fd = "DraggableList-module__item___Ty6qD", gd = "DraggableList-module__dragHandle___FK31c", ut = {
  item: fd,
  dragHandle: gd
}, md = li(({
  "data-plum-id": e,
  items: t,
  onReorder: n,
  className: r,
  variant: o = "default"
}, i) => {
  const s = (l) => {
    if (!l.destination)
      return;
    const u = Array.from(t), [p] = u.splice(l.source.index, 1);
    u.splice(l.destination.index, 0, p), n(u);
  }, c = (l, u) => {
    const p = u === "up" ? l - 1 : l + 1;
    if (p < 0 || p >= t.length) return;
    const a = Array.from(t), [d] = a.splice(l, 1);
    a.splice(p, 0, d), n(a);
  };
  return o === "arrows" ? /* @__PURE__ */ U(Rr, { onDragEnd: s, children: /* @__PURE__ */ U(Fr, { droppableId: "droppable", children: (l) => /* @__PURE__ */ Pe(
    "div",
    C(N({
      ref: (u) => {
        l.innerRef(u), i && (typeof i == "function" ? i(u) : i.current = u);
      },
      className: r,
      "data-plum-id": e
    }, l.droppableProps), {
      children: [
        t.map((u, p) => /* @__PURE__ */ U(
          Lr,
          {
            draggableId: u.id,
            index: p,
            children: (a, d) => /* @__PURE__ */ U(
              "div",
              C(N({
                ref: a.innerRef
              }, a.draggableProps), {
                className: ut.item,
                "data-dragging": d.isDragging,
                style: N({}, a.draggableProps.style),
                children: /* @__PURE__ */ Pe(Bn, { align: "center", gap: 0, style: { width: "100%" }, children: [
                  /* @__PURE__ */ U(
                    "div",
                    C(N({}, a.dragHandleProps), {
                      className: ut.dragHandle,
                      style: {
                        cursor: d.isDragging ? "grabbing" : "grab"
                      },
                      children: /* @__PURE__ */ U(Tn, {})
                    })
                  ),
                  u.content,
                  /* @__PURE__ */ Pe(bi, { ml: "auto", gap: "xs", children: [
                    /* @__PURE__ */ U(
                      Ln,
                      {
                        variant: "tertiary",
                        size: "sm",
                        onClick: () => c(p, "up"),
                        disabled: p === 0,
                        "aria-label": "Move up",
                        children: /* @__PURE__ */ U(gi, {})
                      }
                    ),
                    /* @__PURE__ */ U(
                      Ln,
                      {
                        variant: "tertiary",
                        size: "sm",
                        onClick: () => c(p, "down"),
                        disabled: p === t.length - 1,
                        "aria-label": "Move down",
                        children: /* @__PURE__ */ U(mi, {})
                      }
                    )
                  ] })
                ] })
              })
            )
          },
          u.id
        )),
        l.placeholder
      ]
    })
  ) }) }) : /* @__PURE__ */ U(Rr, { onDragEnd: s, children: /* @__PURE__ */ U(Fr, { droppableId: "droppable", children: (l) => /* @__PURE__ */ Pe(
    "div",
    C(N({
      ref: (u) => {
        l.innerRef(u), i && (typeof i == "function" ? i(u) : i.current = u);
      },
      className: r,
      "data-plum-id": e
    }, l.droppableProps), {
      children: [
        t.map((u, p) => /* @__PURE__ */ U(
          Lr,
          {
            draggableId: u.id,
            index: p,
            children: (a, d) => /* @__PURE__ */ U(
              "div",
              C(N({
                ref: a.innerRef
              }, a.draggableProps), {
                className: ut.item,
                "data-dragging": d.isDragging,
                style: N({}, a.draggableProps.style),
                children: /* @__PURE__ */ Pe(Bn, { align: "center", gap: 0, style: { width: "100%" }, children: [
                  /* @__PURE__ */ U(
                    "div",
                    C(N({}, a.dragHandleProps), {
                      className: ut.dragHandle,
                      style: {
                        cursor: d.isDragging ? "grabbing" : "grab"
                      },
                      children: /* @__PURE__ */ U(Tn, {})
                    })
                  ),
                  u.content
                ] })
              })
            )
          },
          u.id
        )),
        l.placeholder
      ]
    })
  ) }) });
});
md.displayName = "DraggableList";
export {
  md as DraggableList
};
